export const translations = {
  pl: {
    joinNotice: {
      message: 'Dołączono do zespołu!',
    },
    menu: {
      schedule: 'Grafik',
      shiftPlan: 'Plan zmian',
      dashboard: 'Dashboard',
      team: 'Zespół',
      billing: 'Płatności',
      subscription: 'Subskrypcja',
      settings: 'Ustawienia',
      mySchedule: 'Mój Grafik',
      teamSchedule: 'Grafik Zespołu',
      myTeam: 'Mój Zespół',
      availability: 'Dostępność',
      logout: 'Wyloguj się',
      shiftSwaps: 'Zamiany zmian',
      shiftSwapsMobile: 'Zamiany',
      chat: 'Czat',
    },
    cookieConsent: {
      title: 'Prywatność i cookies',
      subtitle: 'Ty decydujesz, czy możemy mierzyć skuteczność strony.',
      description: 'Używamy cookies niezbędnych do działania Schedi oraz, za Twoją zgodą, cookies analitycznych Google Analytics. Analityka pomaga nam sprawdzać, które publiczne strony i formularze działają najlepiej. Nie używamy cookies reklamowych ani remarketingu.',
      necessaryTitle: 'Cookies niezbędne',
      necessaryDescription: 'Obsługują logowanie, bezpieczeństwo, język interfejsu i tryb wyświetlania. Są zawsze aktywne.',
      analyticsTitle: 'Cookies analityczne',
      analyticsDescription: 'Pozwalają mierzyć odwiedziny publicznych stron, źródła ruchu i podstawowe zdarzenia konwersji w Google Analytics.',
      alwaysActive: 'Zawsze aktywne',
      acceptAll: 'Akceptuj wszystkie',
      reject: 'Odrzuć',
      customize: 'Dostosuj',
      save: 'Zapisz wybór',
      back: 'Wróć',
      close: 'Zamknij ustawienia cookies',
      footerLink: 'Ustawienia cookies',
    },
    chat: {
      title: 'Czat zespołu',
      noChannel: 'Brak kanału dla tego zespołu.',
      sendPlaceholder: 'Napisz wiadomość… (@imię aby oznaczyć)',
      send: 'Wyślij',
      loadingMessages: 'Ładowanie wiadomości…',
      loadMore: 'Załaduj starsze',
      errorSend: 'Nie udało się wysłać wiadomości.',
      upgradeTitle: 'Czat dostępny w planie Pro',
      upgradeDesc: 'Aktywuj subskrypcję, aby korzystać z czatu zespołowego.',
      newMessages: 'Nowe wiadomości',
    },
    actions: {
      generate: 'Generuj',
      generateRecurring: 'Wygeneruj stałe zmiany',
      generateRecurringInfo: 'Tworzy wiele zmian naraz wg powtarzającego się wzorca tygodniowego, w wybranym zakresie dat (maks. 3 miesiące).',
      filter: 'Filtruj',
      send: 'Wyślij',
      revoke: 'Cofnij',
      approve: 'Zatwierdź',
      unlock: 'Odblokuj',
      invite: 'Zaproś',
      inviteEmployee: 'Zaproś pracownika',
      month: 'Miesiąc',
      week: 'Tydzień',
      goToShiftPlan: 'Przejdź do Planu zmian',
      autoAssign: 'Auto-przypisz',
      autoAssignShort: 'Auto',
      autoAssignInfo: 'Automatycznie dopasowuje pracowników do otwartych zmian na podstawie ich dostępności i przypisanych ról stanowiskowych.',
    },
    views: {
      staffing: 'Obsada na ten tydzień',
      workload: 'Obciążenie pracowników',
      selectTeam: 'Wybierz zespół'
    },
    dashboard: {
      title: 'Strategiczny przegląd zespołu',
      subtitle: 'Zarządzaj pracownikami w Twoich lokalizacjach',
      allShifts: 'Wszystkie zmiany',
      allShiftsDesc: 'Ilość zaplanowanych zmian',
      scheduleCoverage: 'Pokrycie grafiku',
      scheduleCoverageDesc: 'Procent przypisanych zmian',
      overtime: 'Nadgodziny',
      overtimeDesc: 'Pracownicy powyżej normy',
      teamMembers: 'Pracownicy zespołu',
      teamMembersDesc: 'Podsumowanie godzin dla wybranego okresu',
      weeks: 'tyg.',
      hours: 'godz.',
      yourTeams: 'Twoje Zespoły',
      scheduleExecution: 'Realizacja grafiku',
      shiftsFilled: 'zmian obsadzonych',
      of: 'z',
      shiftsInMonth: 'Zmiany w miesiącu',
      shiftsInWeek: 'Zmiany w tygodniu',
      unfilled: 'nieobsadzonych',
      overtimeAlerts: 'Alerty nadgodzin',
      overTarget: 'Pracownicy powyżej swoich celów',
      allNormal: 'Wszyscy w normie',
      employeeWorkload: 'Obciążenie pracowników',
      rankingByHours: 'Ranking wg godzin —',
      noActiveEmployees: 'Brak aktywnych pracowników w zespole',
      inviteMembersStats: 'Zaproś członków zespołu aby zobaczyć statystyki',
      employee: 'Pracownik',
      hoursCol: 'Godziny',
      payoutEst: 'Wypłata (est.)',
      targetYou: 'Cel / Ty',
      workloadPercentage: 'Obciążenie wpisanego etatu',
      mostHours: 'Najwięcej godzin',
      shiftsCount: 'zmian',
      hoursPerWeek: 'h/tyg',
      onTheEdge: 'Na granicy',
      noShifts: 'Brak zmian',
      ok: 'OK'
    },
    shiftPlan: {
      draft: 'Wersja Robocza',
      pending: 'Oczekuje na zatwierdzenie',
      approved: 'Zatwierdzony',
      rejected: 'Oko poprawki',
      shiftsList: 'Lista zmian',
      filterEmployees: 'Filtruj pracowników',
      clearFilters: 'Wyczyść filtry',
      noEmployeesAlert: 'Brak pracowników. Dodaj ich w sekcji Zespół.',
      lockedMonthAlert: 'Miesiąc jest zablokowany (zatwierdzony). Edycja jest niemożliwa.',
      pendingMonthAlert: 'Miesiąc oczekuje na zatwierdzenie. Niektóre akcje mogą być zablokowane.',
      noShiftsFiltered: 'Brak zmian dla wybranych filtrów.',
      allPositions: 'Wszystkie stanowiska',
      sendForApprovalText: 'Czy na pewno chcesz wysłać grafik na ten miesiąc do zatwierdzenia?',
      sendForApprovalConfirm: 'Tak, wyślij',
      cancel: 'Anuluj'
    },
    autoAssign: {
      title: 'Auto-przypisanie zmian',
      subtitle: 'Dopasuj pracowników do otwartych zmian na podstawie dostępności i ról stanowiskowych',
      summaryOpenShifts: 'otwartych zmian',
      summaryAssigned: 'przypisanych',
      summaryUnassigned: 'nieprzypisanych',
      summaryNoAvailData: 'bez danych dostępności',
      proposalsTitle: 'Propozycje przypisań',
      unassignedTitle: 'Nieprzypisane zmiany',
      legendTitle: 'Legenda ostrzeżeń',
      applyBtn: 'Zastosuj przypisania',
      noOpenTitle: 'Brak otwartych zmian do przypisania.',
      noOpenDesc: 'Wszystkie zmiany w tym miesiącu są już obsadzone.',
      colDate: 'Data',
      colHours: 'Godziny',
      colEmployee: 'Pracownik',
      colRole: 'Rola',
      colWarnings: 'Ostrzeżenia',
      colReason: 'Powód',
      warnUnknownAvailability: 'Brak danych dostępności',
      warnPartialMismatch: 'Częściowa dostępność',
      warnNoRoleMatch: 'Brak kandydatów z rolą',
      warnNoCandidates: 'Brak kandydatów',
      warnTargetExceeded: 'Przekroczony target',
    },
    staffRoles: {
      title: 'Role stanowiskowe',
      rolesCountOne: 'rola',
      rolesCountFew: 'role',
      rolesCountMany: 'ról',
      definedRoles: 'Zdefiniowane role',
      noRolesDefined: 'Brak zdefiniowanych ról. Dodaj pierwszą rolę poniżej.',
      roleNamePlaceholder: 'Nazwa roli (np. Barista)',
      addRole: 'Dodaj rolę',
      deleteRole: 'Usuń rolę',
      assignRolesTitle: 'Przypisanie ról do pracowników',
      assignRole: 'Przypisz rolę',
      removeRole: 'Usuń rolę',
      requiredRole: 'Wymagana rola',
      noRoleRequired: 'Brak (dowolna rola)',
      confirmDeleteTitle: 'Usunąć rolę?',
      confirmDeleteDesc: 'Rola zostanie usunięta z profili wszystkich pracowników. Tej operacji nie można cofnąć.',
      deleteConfirmBtn: 'Usuń rolę',
      deleting: 'Usuwanie...',
    },
    settings: {
      title: 'Ustawienia',
      subtitle: 'Dostosuj aplikację do swoich preferencji',
      language: 'Język aplikacji',
      appearance: 'Wygląd',
      darkMode: 'Tryb Ciemny',
      darkModeDesc: 'Przełącz pomiędzy jasnym a ciemnym motywem',
      finance: 'Finanse',
      hourlyRate: 'Stawka godzinowa',
      hourlyRateDesc: 'Stawka używana do szacowania wypłaty'
    },
    role: {
      manager: 'Kierownik',
      employee: 'Pracownik'
    },
    notifications: {
      title: 'Powiadomienia',
      markAllRead: 'Oznacz wszystkie jako przeczytane',
      empty: 'Brak nowych powiadomień',
      justNow: 'Przed chwilą',
      minutesAgo: 'min. temu',
      hoursAgo: 'godz. temu',
      daysAgo: 'dni temu',
      deleteAll: 'Usuń wszystkie'
    },
    shiftSwap: {
      pageTitle: 'Zamiany zmian',
      pageSubtitle: 'Zarządzaj wnioskami pracowników o zamianę lub oddanie zmian.',
      waitingForYou: 'Czeka na Ciebie',
      totalRequests: 'Wszystkich wniosków',
      pending: 'Oczekujące',
      all: 'Wszystkie',
      noPendingTitle: 'Brak oczekujących wniosków',
      noRequestsTitle: 'Brak wniosków',
      noPendingDesc: 'Wszystkie wnioski zostały rozpatrzone.',
      noRequestsDesc: 'Pracownicy nie złożyli jeszcze żadnych wniosków.',
      statusPendingEmployee: 'Czeka na pracownika',
      statusPendingManager: 'Czeka na Ciebie',
      statusApproved: 'Zatwierdzona',
      statusRejected: 'Odrzucona',
      statusCancelled: 'Anulowana',
      badgeWaitingEmployee: 'Czeka na odpowiedź',
      badgeWaitingManager: 'Czeka na managera',
      giveAway: 'Oddanie',
      giveAwayFull: 'Oddanie zmiany',
      swap: 'Zamiana',
      swapFull: 'Zamiana zmianami',
      shiftUnavailable: 'Zmiana niedostępna',
      shiftUnknown: 'Zmiana nieznana',
      shiftA: 'Zmiana A',
      shiftB: 'Zmiana B',
      unknownMember: 'Nieznany',
      withLabel: 'z:',
      decide: 'Rozpatrz',
      applied: 'Zastosowano',
      rejectedLabel: 'Odrzucono',
      requiresDecision: 'Wymaga Twojej decyzji',
      giveAwayWarning: 'Pracownik chce oddać tę zmianę. Zatwierdzenie spowoduje usunięcie przypisania — zmiana stanie się wolna.',
      employeeNote: 'Notatka pracownika:',
      managerNote: 'Twoja notatka (opcjonalna)',
      managerNotePlaceholder: 'Np. powód odmowy lub komentarz...',
      submittedAt: 'Złożono:',
      reject: 'Odrzuć',
      approve: 'Zatwierdź',
      processing: 'Przetwarzanie...',
      requestTitle: 'Wniosek o zamianę',
      activeRequestTitle: 'Ta zmiana ma już aktywny wniosek',
      activeRequestDesc: 'Poczekaj aż poprzedni wniosek zostanie rozpatrzony lub anuluj go.',
      close: 'Zamknij',
      selectType: 'Wybierz typ wniosku:',
      giveAwayOptionTitle: 'Oddaj zmianę',
      giveAwayOptionDesc: 'Manager zadecyduje kto ją przejmie.',
      swapOptionTitle: 'Zamień zmianami',
      swapOptionDesc: 'Wybierz kolegę i jego zmianę do zamiany.',
      selectColleagueStep: '1. Wybierz kolegę',
      noColleagues: 'Brak innych aktywnych członków zespołu.',
      noColleagueShifts: 'Ten pracownik nie ma przypisanych zmian do zamiany.',
      back: 'Wstecz',
      next: 'Dalej',
      yourShift: 'Twoja zmiana:',
      noteOptional: 'Notatka (opcjonalna)',
      notePlaceholder: 'Np. urlop rodzinny, wizyta lekarska...',
      giveAwayInfo: 'Manager zobaczy Twój wniosek i zadecyduje kto przejmie zmianę.',
      swapInfo: 'Kolega/koleżanka musi najpierw zaakceptować propozycję, a następnie manager zatwierdzi zamianę.',
      sending: 'Wysyłanie...',
      sendRequest: 'Wyślij wniosek',
      selectColleagueError: 'Wybierz kolegę i jego zmianę do zamiany.',
      swapProposal: 'Propozycja zamiany',
      wantsToSwap: 'chce zamienić się zmianami',
      colleagueDefault: 'Kolega/koleżanka',
      colleagueShift: 'Zmiana kolegi',
      yourShiftLabel: 'Twoja zmiana',
      messageFrom: 'Wiadomość od',
      respondInfo: 'Po Twojej akceptacji manager musi jeszcze zatwierdzić zamianę, zanim zmiana stanie się oficjalna.',
      accept: 'Akceptuj'
    },
    team: {
      inviteModal: {
        tabEmail: 'Przez email',
        tabLink: 'Przez link',
        closeButton: 'Zamknij',
      },
      inviteLink: {
        sectionTitle: 'Link do zespołu',
        sectionSubtitle: 'Każdy z tym linkiem może dołączyć jako pracownik, dopóki go nie odwołasz.',
        loading: 'Wczytywanie linku...',
        copy: 'Kopiuj',
        copied: 'Skopiowano!',
        regenerate: 'Wygeneruj nowy',
        regenerateConfirm: 'Regeneracja unieważni obecny link — każdy, kto go ma, nie będzie mógł już dołączyć. Kontynuować?',
        revoke: 'Dezaktywuj',
        activate: 'Aktywuj',
        revokedNotice: 'Link jest odwołany — nikt nie może przez niego dołączyć.',
        error: 'Nie udało się zarządzać linkiem. Spróbuj ponownie.',
      },
    },
    auth: {
      forgotPassword: {
        title: 'Resetuj hasło',
        subtitle: 'Podaj adres email, a wyślemy Ci link do resetowania hasła',
        sendButton: 'Wyślij link resetujący',
        sending: 'Wysyłanie...',
        successMessage: 'Sprawdź skrzynkę email (w tym folder spam) — wysłaliśmy Ci link do resetowania hasła.',
        backToLogin: 'Wróć do logowania',
        errorGeneric: 'Nie udało się wysłać emaila. Spróbuj ponownie.',
      },
      resetPassword: {
        title: 'Nowe hasło',
        subtitle: 'Ustaw nowe hasło dla swojego konta',
        newPassword: 'Nowe hasło',
        confirmPassword: 'Potwierdź hasło',
        submitButton: 'Zmień hasło',
        submitting: 'Zapisywanie...',
        errorMismatch: 'Hasła się nie zgadzają',
        errorShort: 'Hasło musi mieć co najmniej 6 znaków',
        errorGeneric: 'Nie udało się zmienić hasła. Spróbuj ponownie.',
        invalidLink: 'Link do resetowania hasła jest nieprawidłowy lub wygasł',
      },
      forgotPasswordLink: 'Zapomniałeś hasła?',
      passwordResetSuccess: 'Hasło zostało zmienione. Zaloguj się.',
      continueWithGoogle: 'Kontynuuj z Google',
      orSeparator: 'lub',
      login: {
        tagline: 'Zarządzaj grafikiem zespołu w jednym miejscu',
        title: 'Witaj ponownie',
        subtitle: 'Zaloguj się na swoje konto',
        emailLabel: 'Email',
        passwordLabel: 'Hasło',
        submitButton: 'Zaloguj się',
        resendButton: 'Wyślij nowy link weryfikacyjny',
        resendRetry: 'Spróbuj ponownie za {time}',
        noAccount: 'Nie masz konta?',
        registerLink: 'Zarejestruj się',
        errorUnexpected: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
        errorResendEmailRequired: 'Wpisz adres e-mail, aby wysłać ponownie link potwierdzający.',
        errorResendRateLimit: 'Przekroczono limit prób z serwera. Spróbuj ponownie za chwilę.',
        errorResendGeneric: 'Nie udało się wysłać e-maila: {message}',
        successResend: 'Nowy link weryfikacyjny został wysłany! Sprawdź skrzynkę (również SPAM).',
        successConfirmed: 'Email potwierdzony! Zaloguj się, aby kontynuować.',
        errorLinkExpired: 'Link potwierdzający wygasł. Wpisz swój e-mail poniżej i kliknij "Wyślij ponownie", aby otrzymać nowy link.',
        errorVerification: 'Błąd weryfikacji: {desc}',
        invitedGeneric: 'Zaproszono Cię do zespołu! Zaloguj się, aby dołączyć.',
        invitedWithTeam: 'Zaproszono Cię do zespołu "{team}"! Zaloguj się, aby dołączyć.',
        joinLinkInvitedWithTeam: 'Dołączasz do zespołu "{team}". Zaloguj się, aby kontynuować.',
        joinLinkInvitedGeneric: 'Dołączasz do zespołu. Zaloguj się, aby kontynuować.',
      },
      register: {
        tagline: 'Dołącz do nowej ery zarządzania pracą',
        title: 'Utwórz konto',
        subtitle: 'Uzupełnij dane, aby zacząć',
        titleInviteSetup: 'Dokończ konfigurację',
        subtitleInviteSetup: 'Skonfiguruj swoje imię oraz hasło',
        accountTypeLabel: 'Typ konta',
        accountTypeManager: 'Kierownik',
        accountTypeEmployee: 'Pracownik',
        nameLabel: 'Imię i nazwisko',
        emailLabel: 'Email',
        passwordLabel: 'Hasło',
        submitButton: 'Zarejestruj się',
        submitButtonInviteSetup: 'Zapisz i kontynuuj',
        consentTermsPrefix: 'Akceptuję',
        consentTermsLink: 'Regulamin świadczenia usług',
        consentPrivacyPrefix: 'Zapoznałem/am się z',
        consentPrivacyLink: 'Polityką Prywatności',
        consentPrivacySuffix: 'i wyrażam zgodę na przetwarzanie danych osobowych',
        haveAccount: 'Masz już konto?',
        loginLink: 'Zaloguj się',
        inviteBannerTitle: 'Zaproszenie do zespołu',
        inviteBannerInvitedBy: 'Zaproszono przez: {name}',
        joinLinkBannerTitle: 'Dołączasz do zespołu',
        joinLinkBannerLoading: 'Ładowanie informacji o zespole...',
        successConfigured: 'Konto zostało skonfigurowane!',
        successCreated: 'Konto utworzone pomyślnie! Sprawdź swoją skrzynkę e-mail, aby potwierdzić rejestrację.',
        errorUnexpected: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
        seatLimitError: 'Twoje konto zostało utworzone, ale ten zespół jest obecnie pełny. Skontaktuj się z managerem lub spróbuj ponownie później.',
        seatLimitRetry: 'Spróbuj ponownie',
        wrongAccountTitle: 'To zaproszenie jest dla innego konta',
        wrongAccountBody: 'Jesteś zalogowany jako {name} ({email}). Aby skorzystać z tego zaproszenia, wyloguj się i zarejestruj lub zaloguj na odpowiednie konto.',
        wrongAccountLogout: 'Wyloguj się',
      },
      joinTeam: {
        loading: 'Wczytywanie zaproszenia...',
        invalidTitle: 'Link zaproszenia jest nieprawidłowy',
        invalidBody: 'Ten link do dołączenia do zespołu jest nieaktywny lub nie istnieje. Poproś managera o nowy link.',
        backHome: 'Wróć na stronę główną',
        title: 'Zaproszenie do zespołu {team}',
        cta: 'Dołącz jako pracownik',
        alreadyHaveAccount: 'Masz już konto? Zaloguj się',
      },
    },
    billing: {
      pageTitle: 'Zarządzaj subskrypcją',
      currentPlan: 'Aktualny plan',
      usage: 'Zużycie',
      addons: 'Zarządzaj add-onami',
      nextCharge: 'Następny rachunek',
      renewal: 'Następne odnowienie',
      teams: 'Zespoły',
      employees: 'Pracownicy',
      status: {
        active: 'Aktywna',
        trialing: 'Okres próbny',
        past_due: 'Problem z płatnością',
        canceled: 'Anulowana',
      },
      extraTeam: 'Dodatkowy zespół',
      extraSeat: 'Dodatkowy pracownik',
      perMonth: 'zł/mies',
      teamLimitReached: 'Osiągnięto limit zespołów. Dokup dodatkowy zespół w zakładce Subskrypcja.',
      seatLimitReached: 'Osiągnięto limit pracowników. Dokup dodatkowe miejsca w zakładce Subskrypcja.',
      teamsInUse: 'Usuń nadmiarowe zespoły przed obniżeniem planu.',
      seatsInUse: 'Usuń nadmiarowych pracowników lub zaproszenia przed obniżeniem planu.',
      addonSaved: 'Zmiana zapisana. Rachunek zostanie zaktualizowany.',
      paymentFailed: 'Problem z płatnością. Zaktualizuj dane karty, aby zachować dostęp do Schedi.',
      updateCard: 'Aktualizuj kartę →',
      dangerZone: 'Usuwanie konta',
      deleteAccount: 'Usuń konto',
      deleteConfirmPhrase: 'USUŃ MOJE KONTO',
      deleteError: 'Błąd podczas usuwania konta. Skontaktuj się z pomocą techniczną.',
      addonError: 'Błąd podczas zmiany add-onu. Spróbuj ponownie.',
      stripeSecured: 'Płatności obsługiwane bezpiecznie przez Stripe',
      manageInPortal: 'Zarządzaj w portalu Stripe',
      basePlan: 'Plan bazowy',
      addonConfirmAdd: 'Dodaj',
      addonConfirmRemove: 'Usuń',
      addonAccessNow: 'Dostęp od: teraz',
      addonEndOfPeriod: 'Zmiana wejdzie w życie: koniec bieżącego okresu',
      addonNewBill: 'Nowy miesięczny rachunek',
      addonNewLimit: 'Nowy limit',
      addonConfirmTitle: 'Potwierdź zmianę',
      addonCancelBtn: 'Anuluj',
      addonConfirmBtn: 'Potwierdź',
      reviewChanges: 'Przejdź do podsumowania',
      cancelPending: 'Cofnij zmiany',
      currentCost: 'Aktualny rachunek',
      applying: 'Zastosowywanie...',
      deleteAccountTitle: 'Usuń konto',
      deleteAccountConsequences: 'Usunięcie konta jest nieodwracalne. Twoja subskrypcja zostanie anulowana. Zespół zostanie usunięty, ale konta pracowników będą dla nich nadal dostępne. Dane finansowe będą przechowywane przez okres 5 lat.',
      deleteAccountConsequencesEmployee: 'Usunięcie konta jest nieodwracalne. Twoje dane zostaną usunięte i zostaniesz wypisany ze wszystkich zespołów. Tej operacji nie można cofnąć.',
      deleteTypePlaceholder: 'Wpisz: USUŃ MOJE KONTO',
      deleteSubmitBtn: 'Usuń moje konto',
    },
    landing: {
      nav: { features: 'Funkcje', howItWorks: 'Jak działa', pricing: 'Cennik', faq: 'FAQ', blog: 'Blog', contact: 'Kontakt', login: 'Zaloguj się', start: 'Zacznij tutaj', app: 'Przejdź do aplikacji' },
      a11y: { goHome: 'Schedi - przejdź do strony głównej', selectLanguage: 'Wybierz język', toggleTheme: 'Przełącz motyw', openMenu: 'Otwórz menu', closeMenu: 'Zamknij menu' },
      seo: {
        title: 'Program do grafików pracy dla restauracji i gastronomii',
        description: 'Schedi to program do grafików pracy dla restauracji, kawiarni i barów. Twórz harmonogramy zmian, zbieraj dostępność i zatwierdzaj zamiany w jednym miejscu.',
      },
      hero: {
        badge: 'Program do grafików pracy dla gastronomii',
        title1: 'Program do grafików pracy dla restauracji',
        title2: 'Bez Excela.',
        subtitle: 'Twórz grafiki pracy w 3 minuty, zbieraj dostępność pracowników i zatwierdzaj zamiany zmian bez dziesiątek telefonów. Schedi zastępuje Excela i WhatsAppa w restauracjach, kawiarniach, barach i hotelach.',
        cta: 'Wypróbuj za darmo przez 30 dni',
        watch: 'Zobacz jak działa',
        app: 'Otwórz aplikację',
        trust1: 'Grafik gotowy w 3 minuty',
        trust2: 'Wsparcie po polsku',
        trust3: 'Wdrożenie bez IT'
      },
      stats: [
        { target: 3, suffix: ' min', label: 'do pierwszego gotowego grafiku' },
        { target: 30, suffix: ' dni', label: 'darmowego testu, bez zobowiązań' },
        { target: 24, suffix: '/7', label: 'dostęp do grafiku z telefonu' },
        { target: 10, suffix: '', label: 'pracowników w planie startowym' },
      ],
      pain: {
        eyebrow: 'Czy to brzmi znajomo?',
        title: 'Planowanie grafiku powinno być proste.',
        subtitle: 'Managerowie tracą godziny na WhatsApp, poprawianie Excela i pytania o zmiany. Schedi porządkuje ten proces w jednym miejscu.',
        card1: { title: 'WhatsApp i telefony', desc: 'Setki wiadomości o zamianach zmian, nieobecnościach i pytaniach o grafik. Tracisz czas zamiast zarządzać firmą.' },
        card2: { title: 'Excel i błędy', desc: 'Pliki do scalania, udostępniania i poprawiania. Jeden błąd i cały grafik do przeróbki w piątek wieczór.' },
        card3: { title: 'Brak kontroli', desc: 'Nie wiesz kto jest dostępny, kto przekracza normy i ile kosztują nadgodziny. Decyzje podejmujesz w ciemno.' },
      },
      audience: {
        title: 'Dla lokali, w których grafik zmienia się codziennie',
        subtitle: 'Schedi pomaga małym i średnim zespołom zmianowym szybko układać obsadę, zbierać dostępność i utrzymać porządek w komunikacji.',
        items: [
          { title: 'Restauracje', desc: 'Planuj kelnerów, kuchnię i bar pod lunch, kolację, weekendy oraz nagłe nieobecności.', link: 'Grafik dla restauracji' },
          { title: 'Kawiarnie', desc: 'Zbieraj dyspozycyjność baristów i publikuj grafik bez pytań w kilku osobnych czatach.', link: 'Zobacz zastosowanie' },
          { title: 'Bary', desc: 'Obsadzaj wieczory, weekendy i zmiany sezonowe bez ręcznego przepisywania arkuszy.', link: 'Sprawdź funkcje' },
          { title: 'Hotele i usługi', desc: 'Porządkuj recepcję, obsługę i zespoły godzinowe w jednym prostym widoku.', link: 'Poznaj Schedi' },
        ],
      },
      benefits: {
        title: 'Mniej ręcznej pracy. Więcej kontroli nad grafikiem.',
        subtitle: 'Najważniejszy efekt nie polega na ładniejszym arkuszu. Chodzi o mniej błędów, szybsze decyzje i spokojniejszy zespół.',
        items: [
          { metric: '3 min', title: 'Szybszy start', desc: 'Pierwszy grafik możesz przygotować od razu po dodaniu zespołu i podstawowych zmian.' },
          { metric: '1 panel', title: 'Więcej porządku', desc: 'Grafik, dostępność, role, zamiany i powiadomienia są w jednym miejscu.' },
          { metric: 'PDF/CSV', title: 'Lepsze rozliczenia', desc: 'Eksportuj grafiki i raporty bez ręcznego przepisywania danych z arkuszy.' },
        ],
      },
      bento: {
        eyebrow: 'Możliwości',
        title1: 'Jedno narzędzie.',
        title2: 'Wszystko pod kontrolą.',
        schedule: { eyebrow: 'Inteligentny Grafik', title: 'Grafik, który wypełnia się sam', desc: 'Wykrywanie konfliktów, sugestie obsady, zmiany cykliczne jednym kliknięciem. Koniec z ręcznym układaniem.' },
        time: { eyebrow: 'Czas Pracy', title: 'Ewidencja bez Excela', desc: 'Automatyczne liczenie godzin, nadgodzin i przerw.' },
        availability: { eyebrow: 'Dostępność', title: 'Zawsze wiesz kto może przyjść', desc: 'Pracownicy sami podają dostępność w aplikacji. Ty masz ją w jednym widoku.' },
        team: { eyebrow: 'Zespół', title: 'Cały zespół w jednym miejscu', desc: 'Twój zespół w jednym miejscu - pod kontrolą. Dodaj nową osobę w 30 sekund.' },
        reports: { eyebrow: 'Raporty', title: 'Koszty pod kontrolą', desc: 'Eksport PDF i Excel. Analiza godzin, nadgodzin i kosztów obsady.' },
        notifications: { eyebrow: 'Komunikacja', title: 'Koniec z WhatsAppem', desc: 'Grafik opublikowany. Pracownicy dostają powiadomienie. Zmiana zaakceptowana. Manager wie natychmiast.' },
      },
      features: {
        title: 'Wszystko, czego potrzebujesz',
        subtitle: 'w jednej platformie',
        desc: 'Schedi porządkuje planowanie pracy. Skup się na rozwoju biznesu, a grafik zostaw nam.',
        items: {
          team: { title: 'Zarządzanie Zespołem', desc: 'Łatwe dodawanie pracowników, przypisywanie ról i zarządzanie dostępnością w czasie rzeczywistym.' },
          schedule: { title: 'Inteligentny Grafik', desc: 'Automatyczne wykrywanie konfliktów i sugestie obsady. Twórz zmiany cykliczne jednym kliknięciem.' },
          time: { title: 'Śledzenie Czasu', desc: 'Precyzyjna ewidencja czasu pracy. Wykluczanie przerw i automatyczne liczenie nadgodzin.' },
          availability: { title: 'Dostępność', desc: 'Pracownicy sami deklarują dostępność. System blokuje przypisanie zmian w niedostępne dni.' },
          reports: { title: 'Raporty i Koszty', desc: 'Bieżąca estymacja kosztów zmian. Raporty wypełnienia grafiku i alerty budżetowe.' },
          actions: { title: 'Szybkie Akcje', desc: 'Kopiowanie tygodni, szablony zmian i masowe edycje. Oszczędzaj godziny każdego miesiąca.' }
        }
      },
      howItWorks: {
        eyebrow: 'Jak to działa',
        title1: 'Gotowy grafik',
        title2: 'w 3 krokach',
        step1: { title: 'Dodaj pracowników', desc: 'Stwórz zespół w kilka minut i zaproś pracowników e-mailem albo linkiem dołączenia.' },
        step2: { title: 'Zbierz dostępność', desc: 'Pracownicy podają w aplikacji kiedy mogą pracować. Ty widzisz wszystko w jednym widoku bez dzwonienia do każdego z osobna.' },
        step3: { title: 'Opublikuj grafik', desc: 'Ułóż ręcznie lub użyj auto-wypełnienia. Jeden klik i zespół dostaje powiadomienie z gotowym grafikiem.' },
      },
      comparison: {
        title: 'Schedi zamiast arkusza i czatu',
        subtitle: 'Excel wystarcza na start. Gdy dochodzą dostępność, zamiany i kilka ról, dedykowany program do grafików pracy zaczyna oszczędzać czas.',
        headers: { area: 'Obszar', excel: 'Excel i WhatsApp', schedi: 'Schedi' },
        rows: [
          { area: 'Dostępność', excel: 'Deklaracje giną w wiadomościach i komentarzach.', schedi: 'Pracownicy zgłaszają dostępność w jednym miejscu.' },
          { area: 'Zamiany zmian', excel: 'Manager musi ręcznie śledzić ustalenia.', schedi: 'Wniosek przechodzi przez pracownika i managera.' },
          { area: 'Publikacja grafiku', excel: 'Plik trzeba wysłać, poprawić i pilnować wersji.', schedi: 'Gotowy grafik trafia do zespołu z powiadomieniem.' },
          { area: 'Raporty', excel: 'Godziny i koszty trzeba liczyć ręcznie.', schedi: 'Eksport PDF i CSV jest dostępny z aplikacji.' },
        ],
        cta: 'Porównaj Schedi z Excelem',
      },
      roi: {
        eyebrow: 'Kalkulator',
        title1: 'Ile tracisz',
        title2: 'bez Schedi?',
        employees: 'Liczba pracowników',
        hours: 'Godziny na grafik tygodniowo',
        rate: 'Stawka managera (PLN/h)',
        timeLost: 'Czas tracony miesięcznie',
        costLost: 'Koszt dla firmy miesięcznie',
        schediCost: 'Schedi kosztuje',
        savings: 'Oszczędzasz miesięcznie',
        cta: 'Zacznij oszczędzać już dziś',
        ctaSub: 'Wynik jest orientacyjny i pomaga oszacować koszt pracy managera.',
      },
      pricing: {
        title: 'Prosty plan.',
        subtitle: 'Zero niespodzianek.',
        desc: 'Płacisz za to czego używasz. Żadnych ukrytych opłat, żadnych umów.',
        month: 'miesiąc',
        planName: 'Plan Standard',
        badge: 'Bestseller',
        upTo4: 'do 10 pracowników',
        teamDesc: 'Idealny start dla małego zespołu',
        features: {
          schedule: 'Nielimitowany grafik zmianowy',
          availability: 'Zarządzanie dostępnością',
          notifications: 'Automatyczne powiadomienia',
          export: 'Eksport do PDF i Excel',
          timeTracking: 'Ewidencja czasu pracy',
          mobile: 'Widok app-like na urządzeniu mobilnym',
        },
        addons: 'Dodatki',
        extraOrg: 'Dodatkowa lokalizacja',
        extraEmp: 'Dodatkowy pracownik',
        extraOrgDesc: 'Zarządzaj kilkoma oddziałami z jednego konta',
        extraEmpDesc: 'Powyżej 10 osób - skalujesz kiedy chcesz',
        cta: 'Wybierz plan i zacznij',
        vat: 'Ceny netto. Bez umów. Anuluj kiedy chcesz',
        guarantee: 'Bez umów i zobowiązań. Płacisz tak długo jak używasz. Rezygnacja jednym kliknięciem w ustawieniach.',
      },
      testimonials: {
        eyebrow: 'Efekt w praktyce',
        title: 'Co Schedi porządkuje w lokalu',
        note: 'Scenariusz oparty na typowym procesie planowania zmian.',
        items: [
          { title: 'Mniej pytań o grafik', desc: 'Pracownik sprawdza swój grafik z telefonu, a manager nie odpowiada kilka razy dziennie na te same wiadomości.', meta: 'Komunikacja' },
          { title: 'Szybsze poprawki', desc: 'Zmiana dostępności, korekta obsady i publikacja nowej wersji odbywają się w tym samym panelu.', meta: 'Operacje' },
          { title: 'Lepsza kontrola obsady', desc: 'Manager widzi kto może pracować, gdzie brakuje ludzi i które zmiany wymagają reakcji.', meta: 'Planowanie' },
        ],
      },
      faq: {
        eyebrow: 'FAQ',
        title: 'Najczęstsze pytania',
        items: [
          { q: 'Czy pracownicy muszą zainstalować aplikację?', a: 'Nie. Schedi działa w przeglądarce, więc pracownik może sprawdzić grafik i dostępność z telefonu bez instalowania aplikacji mobilnej.' },
          { q: 'Jak długo trwa wdrożenie?', a: 'Pierwszy grafik można ułożyć tego samego dnia. Dodanie pracowników i zebranie dostępności zajmuje zwykle kilka minut.' },
          { q: 'Czy mogę eksportować grafiki do PDF lub Excela?', a: 'Tak. Schedi umożliwia eksport grafiku i raportów do PDF oraz Excela (w formacie CSV).' },
          { q: 'Czy są jakieś ukryte opłaty lub umowy?', a: 'Nie. Płacisz tylko miesięczną subskrypcję, bez żadnych umów na czas określony. Można zrezygnować w dowolnym momencie.' },
          { q: 'Ile kosztuje większy zespół?', a: 'Plan Standard (129 PLN/mies.) obejmuje 1 managera i do 10 pracowników. Każda kolejna osoba to +8 PLN, dodatkowa lokalizacja to +20 PLN.' },
          { q: 'Czy Schedi działa na telefonie?', a: 'Tak. Strona jest dostosowana do działania na urządzeniach mobilnych. Zarówno manager jak i pracownicy mają pełny dostęp z poziomu smartfona.' },
        ],
      },
      cta: {
        eyebrow: 'Zacznij dziś',
        title1: 'Zacznij planować mądrzej.',
        title2: 'Już dziś.',
        subtitle: 'Dołącz do firm, które przestały tracić czas na Excel i WhatsApp.',
        cta: 'Zacznij tutaj',
        trust1: 'Gotowy grafik w 3 minuty',
        trust2: 'Bez umów',
        trust3: 'Wsparcie po polsku',
      },
      footer: {
        copy: '© 2026 Schedi',
        email: 'biuro@schedi.pl',
        privacy: 'Polityka prywatności',
        terms: 'Regulamin',
        faq: 'FAQ',
        blog: 'Blog',
        contact: 'Kontakt',
        description: 'Schedi to program do grafików pracy dla restauracji, kawiarni, barów i małych zespołów zmianowych.',
        product: 'Produkt',
        industries: 'Branże',
        functions: 'Funkcje',
        program: 'Program do grafików pracy',
        restaurant: 'Grafik pracy restauracja',
        cafe: 'Grafik dla kawiarni',
        bar: 'Grafik dla baru',
        hotel: 'Grafik pracy hotel',
        vsExcel: 'Schedi vs Excel',
        availability: 'Dostępność pracowników',
        swaps: 'Zamiana zmian',
        reports: 'Raporty godzin',
        company: 'Firma',
        detailsTitle: 'Dane i zaufanie',
        details: 'Kontakt w sprawach produktu, płatności i ochrony danych: biuro@schedi.pl. Dane prawne znajdują się w regulaminie i polityce prywatności.',
      },
      seoPages: {
        relatedTitle: 'Powiązane strony',
        program: {
          url: '/program-do-grafikow-pracy',
          breadcrumb: 'Program do grafików pracy',
          metaTitle: 'Program do grafików pracy dla gastronomii',
          metaDescription: 'Schedi to program do grafików pracy online dla restauracji, kawiarni i małych firm. Planuj zmiany, zbieraj dostępność i publikuj grafik w jednym miejscu.',
          hero: { badge: 'Program do grafików pracy', title: 'Program do grafików pracy dla małych zespołów', subtitle: 'Schedi pomaga managerom tworzyć grafiki zmianowe, zbierać dostępność pracowników i porządkować komunikację bez Excela.', cta: 'Wypróbuj za darmo', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'Excel przestaje wystarczać, gdy grafik zaczyna żyć', desc: 'Przy kilku pracownikach arkusz działa. Przy zmianach, urlopach, dostępności i zamianach łatwo stracić kontrolę nad wersją grafiku.', items: ['Dostępność pracowników trafia do różnych wiadomości.', 'Zmiany trzeba poprawiać ręcznie w arkuszu.', 'Pracownicy pytają o najnowszą wersję grafiku.', 'Raporty godzin wymagają dodatkowej pracy.'] },
          solution: { title: 'Jedno miejsce na grafik, dostępność i komunikację', desc: 'Schedi porządkuje podstawowe procesy planowania zmian, bez ciężkiego wdrożenia i bez systemu HR dla dużych firm.', items: [{ title: 'Grafik zmianowy online', desc: 'Twórz i poprawiaj zmiany w przejrzystym widoku dla managera.' }, { title: 'Dostępność pracowników', desc: 'Zbieraj deklaracje zespołu przed układaniem grafiku.' }, { title: 'Powiadomienia i eksport', desc: 'Publikuj grafik, informuj zespół i eksportuj dane do PDF lub CSV.' }] },
          cta: { title: 'Ułóż pierwszy grafik bez Excela', desc: 'Zacznij od prostego planu, zaproś zespół i sprawdź, ile ręcznej pracy możesz usunąć z tygodnia managera.', button: 'Zacznij tutaj' },
        },
        restaurant: {
          url: '/grafik-pracy-restauracja',
          breadcrumb: 'Grafik pracy restauracja',
          metaTitle: 'Grafik pracy w restauracji bez Excela',
          metaDescription: 'Twórz grafik pracy dla restauracji, kuchni, sali i baru. Schedi pomaga zbierać dostępność, planować obsadę i zatwierdzać zamiany zmian.',
          hero: { badge: 'Grafik pracy restauracja', title: 'Grafik pracy w restauracji bez Excela i telefonów', subtitle: 'Planuj kuchnię, salę i bar w jednym narzędziu. Schedi ułatwia obsadę lunchu, kolacji, weekendów i nagłych zmian.', cta: 'Wypróbuj w restauracji', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'W gastronomii grafik zmienia się cały czas', desc: 'Weekend, choroba, zmiana dostępności albo prośba o zamianę potrafią rozsypać gotowy plan, jeśli wszystko jest w arkuszu i na czacie.', items: ['Kelnerzy, kuchnia i bar mają różne role oraz dostępność.', 'Zmiany weekendowe wymagają szybkiej reakcji managera.', 'Zamiany ustalane na czacie łatwo pominąć.', 'Pracownicy potrzebują dostępu do grafiku z telefonu.'] },
          solution: { title: 'Schedi porządkuje codzienne planowanie lokalu', desc: 'Aplikacja skupia się na tym, co manager restauracji robi najczęściej: układaniu zmian, poprawkach i komunikacji z zespołem.', items: [{ title: 'Role i obsada', desc: 'Planuj zmiany z uwzględnieniem stanowisk i potrzeb lokalu.' }, { title: 'Dostępność przed grafikiem', desc: 'Zobacz kto może pracować, zanim opublikujesz harmonogram.' }, { title: 'Zamiany pod kontrolą', desc: 'Wnioski o zamianę przechodzą przez proces akceptacji, zamiast ginąć w wiadomościach.' }] },
          cta: { title: 'Zamień arkusz na prosty grafik online', desc: 'Schedi jest stworzone dla managerów, którzy chcą szybciej publikować grafik i ograniczyć liczbę telefonów o zmiany.', button: 'Zacznij za darmo' },
        },
        excel: {
          url: '/schedi-vs-excel',
          breadcrumb: 'Schedi vs Excel',
          metaTitle: 'Schedi vs Excel do grafików pracy',
          metaDescription: 'Porównaj Schedi i Excel przy układaniu grafików pracy. Sprawdź różnice w dostępności, zamianach zmian, publikacji grafiku i raportach.',
          hero: { badge: 'Schedi vs Excel', title: 'Schedi vs Excel do grafików pracy', subtitle: 'Excel jest dobry na start. Schedi zaczyna wygrywać, gdy grafik wymaga dostępności, powiadomień, zamian i eksportu bez ręcznego pilnowania wersji.', cta: 'Przetestuj Schedi', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'Arkusz nie jest procesem planowania', desc: 'Excel przechowuje tabelę, ale nie zbiera dostępności, nie zatwierdza zamian i nie informuje pracowników o nowej wersji grafiku.', items: ['Każda poprawka tworzy ryzyko pracy na starej wersji.', 'Zamiany wymagają ręcznego potwierdzania.', 'Dostępność trzeba kopiować z wiadomości.', 'Raporty godzin zależą od poprawnych formuł.'] },
          solution: { title: 'Schedi dodaje proces wokół grafiku', desc: 'Zamiast zastępować jeden arkusz drugim, Schedi łączy grafik z dostępnością, zespołem, powiadomieniami i eksportem.', items: [{ title: 'Jeden aktualny grafik', desc: 'Zespół widzi aktualną wersję, a manager zarządza zmianami w aplikacji.' }, { title: 'Mniej ręcznych ustaleń', desc: 'Dostępność i zamiany mają swoje miejsce oraz status.' }, { title: 'Eksport bez przepisywania', desc: 'PDF i CSV pomagają przekazać dane dalej bez kopiowania tabel.' }] },
          cta: { title: 'Sprawdź, czy Excel nadal Ci wystarcza', desc: 'Jeśli grafik zajmuje za dużo czasu albo wymaga ciągłego poprawiania, przetestuj Schedi na realnym zespole.', button: 'Wypróbuj za darmo' },
        },
        cafe: {
          url: '/grafik-dla-kawiarni',
          breadcrumb: 'Grafik dla kawiarni',
          metaTitle: 'Grafik pracy dla kawiarni i baristów',
          metaDescription: 'Schedi pomaga układać grafik pracy w kawiarni, zbierać dostępność baristów i publikować zmiany bez arkuszy oraz rozproszonych wiadomości.',
          hero: { badge: 'Grafik dla kawiarni', title: 'Grafik pracy dla kawiarni w jednym widoku', subtitle: 'Planuj baristów, zmiany poranne, popołudniowe i weekendowe w jednym prostym narzędziu online.', cta: 'Wypróbuj w kawiarni', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'Kawiarnia potrzebuje elastycznego grafiku', desc: 'Ruch w kawiarni zmienia się w ciągu dnia, a dostępność studentów, baristów i osób na część etatu bywa różna co tydzień.', items: ['Dostępność trafia do wielu rozmów i notatek.', 'Weekendowe zmiany trzeba szybko uzupełniać.', 'Nowa wersja grafiku ginie w wiadomościach.', 'Manager traci czas na pytania o godziny pracy.'] },
          solution: { title: 'Schedi porządkuje grafik kawiarni', desc: 'W jednym miejscu planujesz obsadę, zbierasz dyspozycyjność i dajesz zespołowi dostęp do aktualnego grafiku.', items: [{ title: 'Dostępność baristów', desc: 'Zbieraj deklaracje przed układaniem tygodnia.' }, { title: 'Zmiany bez arkuszy', desc: 'Edytuj poranki, popołudnia i weekendy w przejrzystym widoku.' }, { title: 'Publikacja dla zespołu', desc: 'Pracownicy widzą aktualny grafik z telefonu.' }] },
          cta: { title: 'Ułóż grafik kawiarni online', desc: 'Przetestuj Schedi na swoim zespole i sprawdź, ile wiadomości o grafiku możesz usunąć z tygodnia.', button: 'Zacznij tutaj' },
        },
        bar: {
          url: '/grafik-dla-baru',
          breadcrumb: 'Grafik dla baru',
          metaTitle: 'Grafik pracy dla baru i zmian wieczornych',
          metaDescription: 'Twórz grafik pracy dla baru, planuj obsadę wieczorów i weekendów, zbieraj dostępność oraz kontroluj zamiany zmian w Schedi.',
          hero: { badge: 'Grafik dla baru', title: 'Grafik pracy dla baru, weekendów i wieczorów', subtitle: 'Schedi pomaga planować barmanów, obsługę sali i zmiany sezonowe bez przepisywania arkuszy.', cta: 'Wypróbuj w barze', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'Wieczorne zmiany wymagają szybkich korekt', desc: 'Bary pracują w godzinach, w których każda nieobecność i zamiana zmiany szybko wpływa na obsadę.', items: ['Zmiany weekendowe są najbardziej wrażliwe na braki.', 'Zamiany ustalane w czacie trudno kontrolować.', 'Dostępność zespołu zmienia się z tygodnia na tydzień.', 'Manager potrzebuje jednej aktualnej wersji grafiku.'] },
          solution: { title: 'Jeden grafik dla całego baru', desc: 'Schedi łączy plan zmian, dostępność i wnioski o zamianę w jednym procesie, bez ręcznego pilnowania wersji.', items: [{ title: 'Obsada wieczorów', desc: 'Planuj zmiany pod realne godziny pracy lokalu.' }, { title: 'Zamiany ze statusem', desc: 'Wniosek ma właściciela, etap i decyzję managera.' }, { title: 'Eksport grafiku', desc: 'Przekazuj gotowy plan do PDF lub CSV bez kopiowania tabel.' }] },
          cta: { title: 'Zamień czat na kontrolowany grafik', desc: 'Jeśli weekendowy grafik wymaga ciągłych korekt, sprawdź Schedi na realnym tygodniu pracy.', button: 'Wypróbuj za darmo' },
        },
        hotel: {
          url: '/grafik-pracy-hotel',
          breadcrumb: 'Grafik pracy hotel',
          metaTitle: 'Grafik pracy hotelu dla recepcji i obsługi',
          metaDescription: 'Schedi pomaga planować grafik pracy hotelu, recepcji, obsługi i zespołów zmianowych. Zbieraj dostępność i publikuj harmonogram online.',
          hero: { badge: 'Grafik pracy hotel', title: 'Grafik pracy hotelu w jednym widoku', subtitle: 'Planuj recepcję, obsługę i zespoły godzinowe bez szukania aktualnej wersji grafiku w arkuszach.', cta: 'Wypróbuj dla hotelu', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'Hotel potrzebuje ciągłości obsady', desc: 'Recepcja, obsługa i dyżury wymagają przewidywalnego planu, ale zmiany dostępności szybko komplikują grafik.', items: ['Różne role wymagają osobnej kontroli obsady.', 'Zmiany poranne, popołudniowe i nocne muszą się uzupełniać.', 'Nieobecności wymagają szybkiego zastępstwa.', 'Zespół potrzebuje dostępu do aktualnego harmonogramu.'] },
          solution: { title: 'Schedi ułatwia planowanie zmian hotelowych', desc: 'Manager widzi zespół, dostępność i grafik w jednym miejscu, a pracownicy mogą sprawdzić swoje zmiany z telefonu.', items: [{ title: 'Role i stanowiska', desc: 'Planuj obsadę według potrzeb recepcji i obsługi.' }, { title: 'Aktualny harmonogram', desc: 'Ogranicz pytania o najnowszą wersję grafiku.' }, { title: 'Raporty godzin', desc: 'Eksportuj dane do dalszych rozliczeń bez ręcznego przepisywania.' }] },
          cta: { title: 'Uporządkuj grafik hotelu online', desc: 'Zacznij od jednego zespołu i sprawdź, czy Schedi pasuje do Twojego sposobu planowania zmian.', button: 'Zacznij tutaj' },
        },
        availability: {
          url: '/funkcje/dostepnosc-pracownikow',
          breadcrumb: 'Dostępność pracowników',
          metaTitle: 'Dostępność pracowników w grafiku pracy',
          metaDescription: 'Zbieraj dostępność pracowników przed układaniem grafiku. Schedi pomaga managerom planować zmiany bez szukania deklaracji w wiadomościach.',
          hero: { badge: 'Dostępność pracowników', title: 'Dostępność pracowników przed ułożeniem grafiku', subtitle: 'Zbieraj deklaracje zespołu w jednym miejscu i planuj zmiany na podstawie aktualnych informacji.', cta: 'Sprawdź dostępność w Schedi', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'Grafik zaczyna się od dostępności', desc: 'Jeśli dyspozycyjność jest w wiadomościach, notatkach i pamięci managera, każdy grafik ma większe ryzyko błędów.', items: ['Deklaracje pracowników łatwo pominąć.', 'Częściowa dostępność wymaga ręcznego sprawdzania.', 'Zmiany trzeba poprawiać po publikacji.', 'Manager nie ma jednego widoku przed planowaniem.'] },
          solution: { title: 'Schedi zbiera deklaracje w jednym miejscu', desc: 'Pracownicy podają kiedy mogą pracować, a manager widzi dostępność przed przypisaniem zmian.', items: [{ title: 'Dostępność dzienna', desc: 'Sprawdź kto może pracować w konkretnym terminie.' }, { title: 'Wzorce tygodniowe', desc: 'Porządkuj powtarzalną dyspozycyjność zespołu.' }, { title: 'Mniej poprawek', desc: 'Planuj zmiany z mniejszym ryzykiem konfliktów.' }] },
          cta: { title: 'Zbieraj dostępność w jednym miejscu', desc: 'Przenieś deklaracje pracowników z czatu do jednego procesu planowania grafiku.', button: 'Wypróbuj Schedi' },
        },
        swaps: {
          url: '/funkcje/zamiana-zmian',
          breadcrumb: 'Zamiana zmian',
          metaTitle: 'Zamiana zmian pracowników pod kontrolą managera',
          metaDescription: 'Obsługuj zamiany zmian w Schedi. Pracownik składa wniosek, druga osoba odpowiada, a manager zatwierdza zmianę w jednym procesie.',
          hero: { badge: 'Zamiana zmian', title: 'Zamiana zmian bez gubienia ustaleń', subtitle: 'Wnioski o zamianę przechodzą przez jasny proces, zamiast znikać w czacie i prywatnych wiadomościach.', cta: 'Zobacz zamiany w Schedi', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'Zamiany na czacie szybko tracą kontekst', desc: 'Gdy pracownicy umawiają się poza grafikiem, manager musi ręcznie sprawdzać kto, kiedy i na co się zgodził.', items: ['Nie wiadomo, która osoba zaakceptowała zmianę.', 'Manager ręcznie aktualizuje grafik.', 'Stara wersja grafiku zostaje w obiegu.', 'Brakuje historii decyzji przy zamianie.'] },
          solution: { title: 'Schedi daje zamianom status i proces', desc: 'Wniosek przechodzi przez pracownika i managera, a grafik można aktualizować bez ręcznego śledzenia wiadomości.', items: [{ title: 'Wniosek o zamianę', desc: 'Pracownik inicjuje zmianę z poziomu aplikacji.' }, { title: 'Akceptacja drugiej osoby', desc: 'Zamiana ma jasną odpowiedź przed decyzją managera.' }, { title: 'Decyzja managera', desc: 'Ostateczna akceptacja zostaje w kontrolowanym procesie.' }] },
          cta: { title: 'Uporządkuj zamiany w zespole', desc: 'Zamień ręczne ustalenia na proces, który manager może zatwierdzić bez szukania wiadomości.', button: 'Wypróbuj za darmo' },
        },
        reports: {
          url: '/funkcje/raporty-godzin',
          breadcrumb: 'Raporty godzin',
          metaTitle: 'Raporty godzin pracy i eksport grafiku',
          metaDescription: 'Eksportuj grafik i raporty godzin pracy do PDF oraz CSV. Schedi pomaga managerom przekazywać dane bez ręcznego przepisywania arkuszy.',
          hero: { badge: 'Raporty godzin', title: 'Raporty godzin pracy bez przepisywania danych', subtitle: 'Eksportuj grafiki, godziny i dane do dalszych rozliczeń bez ręcznego kopiowania tabel.', cta: 'Zobacz raporty w Schedi', secondaryCta: 'Zobacz cennik' },
          problem: { title: 'Raporty z arkusza wymagają dodatkowej pracy', desc: 'Gdy grafik i zmiany są poprawiane ręcznie, eksport godzin zależy od aktualności tabeli i poprawnych formuł.', items: ['Dane trzeba kopiować między plikami.', 'Formuły łatwo uszkodzić przy poprawkach.', 'PDF grafiku powstaje ręcznie.', 'Manager traci czas na porządkowanie raportu.'] },
          solution: { title: 'Schedi ułatwia przekazanie danych dalej', desc: 'Po ułożeniu grafiku możesz eksportować dane w formacie, który łatwiej przekazać zespołowi lub do dalszego rozliczenia.', items: [{ title: 'Eksport PDF', desc: 'Przygotuj czytelny grafik do udostępnienia.' }, { title: 'Eksport CSV', desc: 'Przekazuj dane dalej bez ręcznego przepisywania.' }, { title: 'Lepsza kontrola godzin', desc: 'Analizuj grafik i obsadę w jednym narzędziu.' }] },
          cta: { title: 'Eksportuj grafik bez ręcznej pracy', desc: 'Sprawdź, jak Schedi upraszcza raportowanie godzin w małym zespole zmianowym.', button: 'Zacznij tutaj' },
        },
      },
      seoPageFaq: {
        program: { title: 'Najczęstsze pytania o program do grafików pracy', items: [{ q: 'Co to jest program do grafików pracy?', a: 'To narzędzie online do tworzenia, publikowania i aktualizowania grafików zmianowych. W Schedi manager może też zbierać dostępność, obsługiwać zamiany i eksportować dane.' }, { q: 'Czy Schedi zastępuje Excel?', a: 'Tak, w obszarze planowania zmian. Schedi nie jest arkuszem, tylko procesem wokół grafiku: dostępność, zespół, publikacja, powiadomienia i eksport są w jednym miejscu.' }, { q: 'Czy można zacząć od jednego zespołu?', a: 'Tak. Schedi jest przygotowane dla małych zespołów i może rosnąć razem z firmą, bez ciężkiego wdrożenia IT.' }] },
        restaurant: { title: 'Najczęstsze pytania o grafik pracy restauracji', items: [{ q: 'Czy Schedi nadaje się do restauracji z kuchnią i salą?', a: 'Tak. Możesz planować różne role i zespoły, a pracownicy mają dostęp do aktualnego grafiku z telefonu.' }, { q: 'Czy pracownicy mogą zgłaszać dostępność?', a: 'Tak. Dostępność jest jednym z podstawowych elementów Schedi i pomaga układać grafik przed publikacją.' }, { q: 'Czy zamiany zmian wymagają zgody managera?', a: 'Tak. Zamiany mogą przechodzić przez proces akceptacji, dzięki czemu manager zachowuje kontrolę nad obsadą.' }] },
        excel: { title: 'Najczęstsze pytania o Schedi vs Excel', items: [{ q: 'Kiedy Excel przestaje wystarczać?', a: 'Najczęściej wtedy, gdy pojawiają się częste zamiany, różna dostępność pracowników, kilka ról i potrzeba szybkiej publikacji aktualnej wersji grafiku.' }, { q: 'Czy Schedi eksportuje dane do arkusza?', a: 'Tak. Możesz eksportować dane do CSV, jeśli potrzebujesz przekazać je dalej lub połączyć z innym procesem.' }, { q: 'Czy trzeba od razu przenosić cały proces?', a: 'Nie. Możesz zacząć od jednego zespołu i sprawdzić Schedi na realnym grafiku pracy.' }] },
        cafe: { title: 'Najczęstsze pytania o grafik kawiarni', items: [{ q: 'Czy Schedi sprawdzi się przy baristach na część etatu?', a: 'Tak. Dostępność pracowników można zebrać przed ułożeniem grafiku, co pomaga przy elastycznych zespołach.' }, { q: 'Czy grafik działa na telefonie?', a: 'Tak. Manager i pracownicy mogą korzystać ze Schedi w przeglądarce na urządzeniu mobilnym.' }, { q: 'Czy mogę eksportować grafik kawiarni?', a: 'Tak. Schedi wspiera eksport grafiku i danych do PDF oraz CSV.' }] },
        bar: { title: 'Najczęstsze pytania o grafik baru', items: [{ q: 'Czy Schedi pomaga przy weekendowych zmianach?', a: 'Tak. Możesz planować obsadę wieczorów i weekendów oraz szybciej reagować na zmiany dostępności.' }, { q: 'Czy zamiany zmian są widoczne dla managera?', a: 'Tak. Wnioski o zamianę mają status i mogą wymagać akceptacji managera.' }, { q: 'Czy zespół widzi aktualną wersję grafiku?', a: 'Tak. Pracownicy mogą sprawdzić aktualny grafik z telefonu.' }] },
        hotel: { title: 'Najczęstsze pytania o grafik hotelu', items: [{ q: 'Czy Schedi obsługuje różne role w hotelu?', a: 'Tak. Możesz planować zespół według ról i potrzeb obsady.' }, { q: 'Czy Schedi jest systemem HR?', a: 'Nie. Schedi skupia się na grafiku pracy, dostępności, zamianach i podstawowych raportach dla zespołów zmianowych.' }, { q: 'Czy można zacząć od recepcji?', a: 'Tak. Możesz wdrożyć Schedi najpierw dla jednego zespołu i później rozszerzać użycie.' }] },
        availability: { title: 'Najczęstsze pytania o dostępność pracowników', items: [{ q: 'Jak pracownik podaje dostępność?', a: 'Pracownik korzysta z aplikacji w przeglądarce i wpisuje kiedy może pracować. Manager widzi deklaracje przed układaniem grafiku.' }, { q: 'Czy można oznaczyć częściową dostępność?', a: 'Tak. Schedi obsługuje dostępność pełną, częściową i niedostępność.' }, { q: 'Czy dostępność zmniejsza liczbę poprawek?', a: 'Pomaga ograniczyć błędy, bo manager planuje na podstawie deklaracji zebranych w jednym miejscu.' }] },
        swaps: { title: 'Najczęstsze pytania o zamianę zmian', items: [{ q: 'Kto zatwierdza zamianę zmiany?', a: 'Proces może obejmować odpowiedź drugiego pracownika i decyzję managera, żeby zachować kontrolę nad obsadą.' }, { q: 'Czy zamiany zastępują ustalenia na czacie?', a: 'Tak. Zamiast szukać ustaleń w wiadomościach, manager widzi wniosek i jego status w aplikacji.' }, { q: 'Czy można oddać zmianę?', a: 'Schedi wspiera przepływ oddania zmiany oraz klasycznej zamiany między pracownikami.' }] },
        reports: { title: 'Najczęstsze pytania o raporty godzin', items: [{ q: 'Jakie eksporty obsługuje Schedi?', a: 'Schedi umożliwia eksport do PDF i CSV, dzięki czemu łatwiej przekazać grafik lub dane dalej.' }, { q: 'Czy raporty zastępują system kadrowy?', a: 'Nie. Raporty pomagają uporządkować dane z grafiku, ale nie zastępują pełnego systemu kadrowo-płacowego.' }, { q: 'Czy eksport wymaga ręcznego przepisywania?', a: 'Nie. Dane pochodzą z grafiku w aplikacji, więc ograniczasz ręczne kopiowanie tabel.' }] },
      },
      contact: {
        title: 'Skontaktuj się z nami',
        desc: 'Masz pytania? Jesteśmy tutaj, aby pomóc Twojemu biznesowi rosnąć.',
        emailLabel: 'Email',
        phoneLabel: 'Telefon',
        addressLabel: 'Adres',
        form: {
          name: 'Imię i nazwisko',
          email: 'Adres email',
          message: 'Wiadomość',
          placeholder: 'Jak możemy Ci pomóc?',
          send: 'Wyślij wiadomość'
        }
      }
    }
  },
  en: {
    joinNotice: {
      message: 'Joined the team!',
    },
    menu: {
      schedule: 'Schedule',
      shiftPlan: 'Shift Plan',
      dashboard: 'Dashboard',
      team: 'Team',
      billing: 'Billing',
      subscription: 'Subscription',
      settings: 'Settings',
      mySchedule: 'My Schedule',
      teamSchedule: 'Team Schedule',
      myTeam: 'My Team',
      availability: 'Availability',
      logout: 'Logout',
      shiftSwaps: 'Shift Exchanges',
      shiftSwapsMobile: 'Exchanges',
      chat: 'Chat',
    },
    cookieConsent: {
      title: 'Privacy and cookies',
      subtitle: 'You decide whether we can measure website performance.',
      description: 'We use cookies required for Schedi to work and, with your consent, Google Analytics cookies. Analytics helps us understand which public pages and forms perform best. We do not use advertising cookies or remarketing.',
      necessaryTitle: 'Necessary cookies',
      necessaryDescription: 'They support login, security, interface language and display mode. They are always active.',
      analyticsTitle: 'Analytics cookies',
      analyticsDescription: 'They let us measure visits to public pages, traffic sources and basic conversion events in Google Analytics.',
      alwaysActive: 'Always active',
      acceptAll: 'Accept all',
      reject: 'Reject',
      customize: 'Customize',
      save: 'Save choice',
      back: 'Back',
      close: 'Close cookie settings',
      footerLink: 'Cookie settings',
    },
    chat: {
      title: 'Team Chat',
      noChannel: 'No channel for this team.',
      sendPlaceholder: 'Write a message… (@name to mention)',
      send: 'Send',
      loadingMessages: 'Loading messages…',
      loadMore: 'Load older',
      errorSend: 'Failed to send message.',
      upgradeTitle: 'Chat available on Pro plan',
      upgradeDesc: 'Activate a subscription to use team chat.',
      newMessages: 'New messages',
    },
    actions: {
      generate: 'Generate',
      generateRecurring: 'Generate recurring',
      generateRecurringInfo: 'Creates multiple shifts at once based on a repeating weekly pattern, within a chosen date range (max. 3 months).',
      filter: 'Filter',
      send: 'Send',
      revoke: 'Revoke',
      approve: 'Approve',
      unlock: 'Unlock',
      invite: 'Invite',
      inviteEmployee: 'Invite employee',
      month: 'Month',
      week: 'Week',
      goToShiftPlan: 'Go to Shift Plan',
      autoAssign: 'Auto-assign',
      autoAssignShort: 'Auto',
      autoAssignInfo: 'Automatically matches employees to open shifts based on their availability and assigned staff roles.',
    },
    views: {
      staffing: 'Staffing for this week',
      workload: 'Employee workload',
      selectTeam: 'Select team'
    },
    dashboard: {
      title: 'Team Strategic Overview',
      subtitle: 'Manage employees across your locations',
      allShifts: 'All shifts',
      allShiftsDesc: 'Number of planned shifts',
      scheduleCoverage: 'Schedule coverage',
      scheduleCoverageDesc: 'Percentage of assigned shifts',
      overtime: 'Overtime',
      overtimeDesc: 'Employees over target',
      teamMembers: 'Team members',
      teamMembersDesc: 'Hours summary for selected period',
      weeks: 'wks',
      hours: 'hrs',
      yourTeams: 'Your Teams',
      scheduleExecution: 'Schedule execution',
      shiftsFilled: 'shifts filled',
      of: 'of',
      shiftsInMonth: 'Shifts in month',
      shiftsInWeek: 'Shifts in week',
      unfilled: 'unfilled',
      overtimeAlerts: 'Overtime alerts',
      overTarget: 'Employees over their targets',
      allNormal: 'All within normal',
      employeeWorkload: 'Employee workload',
      rankingByHours: 'Ranking by hours —',
      noActiveEmployees: 'No active employees in the team',
      inviteMembersStats: 'Invite team members to view statistics',
      employee: 'Employee',
      hoursCol: 'Hours',
      payoutEst: 'Payout (est.)',
      targetYou: 'Target / You',
      workloadPercentage: 'Target workload percentage',
      mostHours: 'Most hours',
      shiftsCount: 'shifts',
      hoursPerWeek: 'h/wk',
      onTheEdge: 'On the edge',
      noShifts: 'No shifts',
      ok: 'OK'
    },
    shiftPlan: {
      draft: 'Draft',
      pending: 'Pending approval',
      approved: 'Approved',
      rejected: 'Needs improvement',
      shiftsList: 'Shift list',
      filterEmployees: 'Filter employees',
      clearFilters: 'Clear filters',
      noEmployeesAlert: 'No employees. Add them in the Team section.',
      lockedMonthAlert: 'Month is locked (approved). Editing is not possible.',
      pendingMonthAlert: 'Month is pending approval. Some actions may be blocked.',
      noShiftsFiltered: 'No shifts for selected filters.',
      allPositions: 'All positions',
      sendForApprovalText: 'Are you sure you want to send this month\'s schedule for approval?',
      sendForApprovalConfirm: 'Yes, send',
      cancel: 'Cancel'
    },
    autoAssign: {
      title: 'Auto-assign shifts',
      subtitle: 'Match employees to open shifts based on availability and staff roles',
      summaryOpenShifts: 'open shifts',
      summaryAssigned: 'assigned',
      summaryUnassigned: 'unassigned',
      summaryNoAvailData: 'without availability data',
      proposalsTitle: 'Assignment proposals',
      unassignedTitle: 'Unassigned shifts',
      legendTitle: 'Warning legend',
      applyBtn: 'Apply assignments',
      noOpenTitle: 'No open shifts to assign.',
      noOpenDesc: 'All shifts this month are already staffed.',
      colDate: 'Date',
      colHours: 'Hours',
      colEmployee: 'Employee',
      colRole: 'Role',
      colWarnings: 'Warnings',
      colReason: 'Reason',
      warnUnknownAvailability: 'No availability data',
      warnPartialMismatch: 'Partial availability',
      warnNoRoleMatch: 'No candidates with role',
      warnNoCandidates: 'No candidates',
      warnTargetExceeded: 'Target exceeded',
    },
    staffRoles: {
      title: 'Staff Roles',
      rolesCountOne: 'role',
      rolesCountFew: 'roles',
      rolesCountMany: 'roles',
      definedRoles: 'Defined roles',
      noRolesDefined: 'No roles defined. Add the first role below.',
      roleNamePlaceholder: 'Role name (e.g. Barista)',
      addRole: 'Add role',
      deleteRole: 'Delete role',
      assignRolesTitle: 'Assign roles to employees',
      assignRole: 'Assign role',
      removeRole: 'Remove role',
      requiredRole: 'Required role',
      noRoleRequired: 'None (any role)',
      confirmDeleteTitle: 'Delete role?',
      confirmDeleteDesc: 'This role will be removed from all employee profiles. This action cannot be undone.',
      deleteConfirmBtn: 'Delete role',
      deleting: 'Deleting...',
    },
    settings: {
      title: 'Settings',
      subtitle: 'Customize the application to your preferences',
      language: 'App Language',
      appearance: 'Appearance',
      darkMode: 'Dark Mode',
      darkModeDesc: 'Switch between light and dark themes',
      finance: 'Finance',
      hourlyRate: 'Hourly Rate',
      hourlyRateDesc: 'Rate used for estimated salary calculation'
    },
    role: {
      manager: 'Manager',
      employee: 'Employee'
    },
    notifications: {
      title: 'Notifications',
      markAllRead: 'Mark all as read',
      empty: 'No new notifications',
      justNow: 'Just now',
      minutesAgo: 'min. ago',
      hoursAgo: 'hr. ago',
      daysAgo: 'days ago',
      deleteAll: 'Delete all'
    },
    shiftSwap: {
      pageTitle: 'Shift Exchanges',
      pageSubtitle: 'Manage employee requests to swap or give away shifts.',
      waitingForYou: 'Waiting for You',
      totalRequests: 'Total Requests',
      pending: 'Pending',
      all: 'All',
      noPendingTitle: 'No pending requests',
      noRequestsTitle: 'No requests',
      noPendingDesc: 'All requests have been processed.',
      noRequestsDesc: 'Employees have not submitted any requests yet.',
      statusPendingEmployee: 'Waiting for employee',
      statusPendingManager: 'Waiting for you',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      badgeWaitingEmployee: 'Waiting for response',
      badgeWaitingManager: 'Waiting for manager',
      giveAway: 'Give Away',
      giveAwayFull: 'Give Away Shift',
      swap: 'Swap',
      swapFull: 'Swap Shifts',
      shiftUnavailable: 'Shift unavailable',
      shiftUnknown: 'Unknown shift',
      shiftA: 'Shift A',
      shiftB: 'Shift B',
      unknownMember: 'Unknown',
      withLabel: 'with:',
      decide: 'Review',
      applied: 'Applied',
      rejectedLabel: 'Rejected',
      requiresDecision: 'Requires your decision',
      giveAwayWarning: 'The employee wants to give away this shift. Approving will remove the assignment — the shift will become open.',
      employeeNote: 'Employee note:',
      managerNote: 'Your note (optional)',
      managerNotePlaceholder: 'E.g. reason for rejection or comment...',
      submittedAt: 'Submitted:',
      reject: 'Reject',
      approve: 'Approve',
      processing: 'Processing...',
      requestTitle: 'Swap Request',
      activeRequestTitle: 'This shift already has an active request',
      activeRequestDesc: 'Wait until the previous request is processed or cancel it.',
      close: 'Close',
      selectType: 'Select request type:',
      giveAwayOptionTitle: 'Give Away Shift',
      giveAwayOptionDesc: 'Manager will decide who takes it.',
      swapOptionTitle: 'Swap Shifts',
      swapOptionDesc: 'Select a colleague and their shift to swap with.',
      selectColleagueStep: '1. Select a colleague',
      noColleagues: 'No other active team members.',
      noColleagueShifts: 'This employee has no assigned shifts to swap.',
      back: 'Back',
      next: 'Next',
      yourShift: 'Your shift:',
      noteOptional: 'Note (optional)',
      notePlaceholder: 'E.g. family leave, doctor appointment...',
      giveAwayInfo: 'Manager will see your request and decide who takes the shift.',
      swapInfo: 'The colleague must first accept the proposal, then the manager will approve the swap.',
      sending: 'Sending...',
      sendRequest: 'Send Request',
      selectColleagueError: 'Select a colleague and their shift to swap.',
      swapProposal: 'Swap Proposal',
      wantsToSwap: 'wants to swap shifts',
      colleagueDefault: 'Colleague',
      colleagueShift: "Colleague's shift",
      yourShiftLabel: 'Your shift',
      messageFrom: 'Message from',
      respondInfo: 'After your acceptance, the manager must still approve the swap before it becomes official.',
      accept: 'Accept'
    },
    team: {
      inviteModal: {
        tabEmail: 'By email',
        tabLink: 'By link',
        closeButton: 'Close',
      },
      inviteLink: {
        sectionTitle: 'Team invite link',
        sectionSubtitle: 'Anyone with this link can join as an employee until you revoke it.',
        loading: 'Loading link...',
        copy: 'Copy',
        copied: 'Copied!',
        regenerate: 'Regenerate',
        regenerateConfirm: 'Regenerating will invalidate the current link — anyone holding it will no longer be able to join. Continue?',
        revoke: 'Revoke',
        activate: 'Activate',
        revokedNotice: 'This link is revoked — no one can join through it.',
        error: 'Failed to manage the link. Please try again.',
      },
    },
    auth: {
      forgotPassword: {
        title: 'Reset Password',
        subtitle: 'Enter your email address and we\'ll send you a reset link',
        sendButton: 'Send Reset Link',
        sending: 'Sending...',
        successMessage: 'Check your inbox (including spam) — we\'ve sent you a password reset link.',
        backToLogin: 'Back to Login',
        errorGeneric: 'Failed to send email. Please try again.',
      },
      resetPassword: {
        title: 'New Password',
        subtitle: 'Set a new password for your account',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        submitButton: 'Change Password',
        submitting: 'Saving...',
        errorMismatch: 'Passwords do not match',
        errorShort: 'Password must be at least 6 characters',
        errorGeneric: 'Failed to change password. Please try again.',
        invalidLink: 'Password reset link is invalid or has expired',
      },
      forgotPasswordLink: 'Forgot your password?',
      passwordResetSuccess: 'Password changed. Please log in.',
      continueWithGoogle: 'Continue with Google',
      orSeparator: 'or',
      login: {
        tagline: 'Manage your team\'s schedule in one place',
        title: 'Welcome back',
        subtitle: 'Log in to your account',
        emailLabel: 'Email',
        passwordLabel: 'Password',
        submitButton: 'Log in',
        resendButton: 'Send new verification link',
        resendRetry: 'Try again in {time}',
        noAccount: 'Don\'t have an account?',
        registerLink: 'Sign up',
        errorUnexpected: 'An unexpected error occurred. Please try again.',
        errorResendEmailRequired: 'Enter your email address to resend the confirmation link.',
        errorResendRateLimit: 'Server rate limit exceeded. Please try again shortly.',
        errorResendGeneric: 'Failed to send email: {message}',
        successResend: 'A new verification link has been sent! Check your inbox (including spam).',
        successConfirmed: 'Email confirmed! Log in to continue.',
        errorLinkExpired: 'The confirmation link has expired. Enter your email below and click "Resend" to get a new link.',
        errorVerification: 'Verification error: {desc}',
        invitedGeneric: 'You\'ve been invited to a team! Log in to join.',
        invitedWithTeam: 'You\'ve been invited to the team "{team}"! Log in to join.',
        joinLinkInvitedWithTeam: 'You\'re joining the team "{team}". Log in to continue.',
        joinLinkInvitedGeneric: 'You\'re joining a team. Log in to continue.',
      },
      register: {
        tagline: 'Join the new era of work management',
        title: 'Create an account',
        subtitle: 'Fill in your details to get started',
        titleInviteSetup: 'Finish setting up',
        subtitleInviteSetup: 'Set your name and password',
        accountTypeLabel: 'Account type',
        accountTypeManager: 'Manager',
        accountTypeEmployee: 'Employee',
        nameLabel: 'Full name',
        emailLabel: 'Email',
        passwordLabel: 'Password',
        submitButton: 'Sign up',
        submitButtonInviteSetup: 'Save and continue',
        consentTermsPrefix: 'I accept the',
        consentTermsLink: 'Terms of Service',
        consentPrivacyPrefix: 'I have read the',
        consentPrivacyLink: 'Privacy Policy',
        consentPrivacySuffix: 'and consent to the processing of my personal data',
        haveAccount: 'Already have an account?',
        loginLink: 'Log in',
        inviteBannerTitle: 'Team invitation',
        inviteBannerInvitedBy: 'Invited by: {name}',
        joinLinkBannerTitle: 'Joining team',
        joinLinkBannerLoading: 'Loading team info...',
        successConfigured: 'Your account has been set up!',
        successCreated: 'Account created successfully! Check your inbox to confirm your registration.',
        errorUnexpected: 'An unexpected error occurred. Please try again.',
        seatLimitError: 'Your account was created, but this team is currently full. Contact your manager or try again later.',
        seatLimitRetry: 'Try again',
        wrongAccountTitle: 'This invite is for a different account',
        wrongAccountBody: 'You\'re logged in as {name} ({email}). To use this invite, log out and register or log in with the right account.',
        wrongAccountLogout: 'Log out',
      },
      joinTeam: {
        loading: 'Loading invitation...',
        invalidTitle: 'This invite link is invalid',
        invalidBody: 'This team join link is inactive or doesn\'t exist. Ask your manager for a new link.',
        backHome: 'Back to homepage',
        title: 'Invitation to join {team}',
        cta: 'Join as employee',
        alreadyHaveAccount: 'Already have an account? Log in',
      },
    },
    billing: {
      pageTitle: 'Manage Subscription',
      currentPlan: 'Current Plan',
      usage: 'Usage',
      addons: 'Manage Add-ons',
      nextCharge: 'Next charge',
      renewal: 'Next renewal',
      teams: 'Teams',
      employees: 'Employees',
      status: {
        active: 'Active',
        trialing: 'Free trial',
        past_due: 'Payment issue',
        canceled: 'Canceled',
      },
      extraTeam: 'Extra Team',
      extraSeat: 'Extra Seat',
      perMonth: 'PLN/mo',
      teamLimitReached: 'Team limit reached. Purchase an extra team in the Subscription tab.',
      seatLimitReached: 'Employee limit reached. Purchase extra seats in the Subscription tab.',
      teamsInUse: 'Remove excess teams before downgrading.',
      seatsInUse: 'Remove excess employees or invitations before downgrading.',
      addonSaved: 'Change saved. Your bill will be updated.',
      paymentFailed: 'Payment issue. Update your card details to keep access to Schedi.',
      updateCard: 'Update card →',
      dangerZone: 'Deleting the account',
      deleteAccount: 'Delete account',
      deleteConfirmPhrase: 'DELETE MY ACCOUNT',
      deleteError: 'Error deleting account. Please contact support.',
      addonError: 'Error updating add-on. Please try again.',
      stripeSecured: 'Payments securely processed by Stripe',
      manageInPortal: 'Manage in Stripe portal',
      basePlan: 'Base plan',
      addonConfirmAdd: 'Add',
      addonConfirmRemove: 'Remove',
      addonAccessNow: 'Access from: now',
      addonEndOfPeriod: 'Change takes effect: end of current period',
      addonNewBill: 'New monthly bill',
      addonNewLimit: 'New limit',
      addonConfirmTitle: 'Confirm change',
      addonCancelBtn: 'Cancel',
      addonConfirmBtn: 'Confirm',
      reviewChanges: 'Review changes',
      cancelPending: 'Discard changes',
      currentCost: 'Current bill',
      applying: 'Applying...',
      deleteAccountTitle: 'Delete account',
      deleteAccountConsequences: 'Account deletion is irreversible. Your subscription will be canceled. The team will be removed, but employee accounts will remain accessible to them. Financial data will be stored for 5 years.',
      deleteAccountConsequencesEmployee: 'Account deletion is irreversible. Your data will be deleted and you will be removed from all teams. This action cannot be undone.',
      deleteTypePlaceholder: 'Type: DELETE MY ACCOUNT',
      deleteSubmitBtn: 'Delete my account',
    },
    landing: {
      nav: { features: 'Features', howItWorks: 'How it works', pricing: 'Pricing', faq: 'FAQ', blog: 'Blog', contact: 'Contact', login: 'Log In', start: 'Start here', app: 'Go to App' },
      a11y: { goHome: 'Schedi - go to homepage', selectLanguage: 'Select language', toggleTheme: 'Toggle theme', openMenu: 'Open menu', closeMenu: 'Close menu' },
      seo: {
        title: 'Work schedule software for restaurants and hospitality',
        description: 'Schedi is work schedule software for restaurants, cafes and bars. Create shift schedules, collect availability and approve shift swaps in one place.',
      },
      hero: {
        badge: 'Work schedule software for hospitality',
        title1: 'Work schedule software for restaurants',
        title2: 'No Excel.',
        subtitle: 'Build work schedules in 3 minutes, collect employee availability, and approve shift swaps without dozens of phone calls. Schedi replaces Excel and WhatsApp for restaurants, cafes, bars, and hotels.',
        cta: 'Try free for 30 days',
        watch: 'See how it works',
        app: 'Open App',
        trust1: 'Schedule ready in 3 minutes',
        trust2: 'Polish support',
        trust3: 'No IT setup needed'
      },
      stats: [
        { target: 3, suffix: ' min', label: 'to your first ready schedule' },
        { target: 30, suffix: ' days', label: 'free trial, no commitment' },
        { target: 24, suffix: '/7', label: 'access to the schedule from your phone' },
        { target: 10, suffix: '', label: 'employees in the starter plan' },
      ],
      pain: {
        eyebrow: 'Does this sound familiar?',
        title: 'Scheduling should be straightforward.',
        subtitle: 'Managers lose hours to WhatsApp, Excel fixes and shift questions. Schedi organizes that process in one place.',
        card1: { title: 'WhatsApp & phone calls', desc: 'Hundreds of messages about shift swaps, absences, and schedule questions. You lose time instead of running your business.' },
        card2: { title: 'Excel & errors', desc: 'Files to merge, share, and fix. One mistake and the whole schedule needs redoing on a Friday evening.' },
        card3: { title: 'No control', desc: 'You don\'t know who\'s available, who\'s exceeding their hours, or how much overtime costs. Decisions made in the dark.' },
      },
      audience: {
        title: 'For workplaces where the schedule changes every day',
        subtitle: 'Schedi helps small and mid-sized shift teams plan staffing, collect availability and keep communication clear.',
        items: [
          { title: 'Restaurants', desc: 'Plan servers, kitchen and bar teams around lunch, dinner, weekends and sudden absences.', link: 'Schedule for restaurants' },
          { title: 'Cafes', desc: 'Collect barista availability and publish schedules without scattered chat messages.', link: 'See the use case' },
          { title: 'Bars', desc: 'Staff evenings, weekends and seasonal shifts without rewriting spreadsheets by hand.', link: 'Check features' },
          { title: 'Hotels and services', desc: 'Organize reception, service and hourly teams in one simple view.', link: 'Explore Schedi' },
        ],
      },
      benefits: {
        title: 'Less manual work. More control over the schedule.',
        subtitle: 'The point is not a prettier spreadsheet. It is fewer mistakes, faster decisions and a calmer team.',
        items: [
          { metric: '3 min', title: 'Faster start', desc: 'Prepare your first schedule right after adding the team and basic shifts.' },
          { metric: '1 panel', title: 'More order', desc: 'Schedule, availability, roles, swaps and notifications live in one place.' },
          { metric: 'PDF/CSV', title: 'Better handoffs', desc: 'Export schedules and reports without manually copying spreadsheet data.' },
        ],
      },
      bento: {
        eyebrow: 'Features',
        title1: 'One tool.',
        title2: 'Everything under control.',
        schedule: { eyebrow: 'Smart Schedule', title: 'Schedule that fills itself', desc: 'Conflict detection, staffing suggestions, recurring shifts with one click. No more manual arrangement.' },
        time: { eyebrow: 'Time Tracking', title: 'Tracking without Excel', desc: 'Automatic hours, overtime, and break calculation.' },
        availability: { eyebrow: 'Availability', title: 'Always know who can come', desc: 'Employees enter their availability in the app. You see it all in one view.' },
        team: { eyebrow: 'Team', title: 'Whole team in one place', desc: 'Your team stays in one place and under control. Add a new person in 30 seconds.' },
        reports: { eyebrow: 'Reports', title: 'Costs under control', desc: 'PDF and Excel export. Hours, overtime, and staffing cost analysis.' },
        notifications: { eyebrow: 'Communication', title: 'No more WhatsApp', desc: 'Schedule published. Employees get notified. Shift accepted. The manager knows immediately.' },
      },
      features: {
        title: 'Everything you need',
        subtitle: 'in one platform',
        desc: 'Schedi organizes work planning. Focus on business growth, leave the schedule to us.',
        items: {
          team: { title: 'Team Management', desc: 'Easily add employees, assign roles, and manage availability in real-time.' },
          schedule: { title: 'Smart Schedule', desc: 'Automatic conflict detection and staffing suggestions. Create recurring shifts with one click.' },
          time: { title: 'Time Tracking', desc: 'Precise work time recording. Break exclusions and automatic overtime calculation.' },
          availability: { title: 'Availability', desc: 'Employees declare availability themselves. System blocks assigning shifts on unavailable days.' },
          reports: { title: 'Reports & Costs', desc: 'Current shift cost estimation. Schedule fill rate reports and budget alerts.' },
          actions: { title: 'Quick Actions', desc: 'Copy weeks, shift templates, and bulk edits. Save hours every month.' }
        }
      },
      howItWorks: {
        eyebrow: 'How it works',
        title1: 'Ready schedule',
        title2: 'in 3 steps',
        step1: { title: 'Add employees', desc: 'Create a team in minutes and invite employees by email or join link.' },
        step2: { title: 'Collect availability', desc: 'Employees enter when they can work in the app. You see everything in one view without calling everyone individually.' },
        step3: { title: 'Publish schedule', desc: 'Arrange manually or use auto-fill. One click and the whole team gets a notification with the ready schedule.' },
      },
      comparison: {
        title: 'Schedi instead of spreadsheets and chat',
        subtitle: 'Excel works at the start. When availability, swaps and multiple roles appear, dedicated scheduling software starts saving time.',
        headers: { area: 'Area', excel: 'Excel and WhatsApp', schedi: 'Schedi' },
        rows: [
          { area: 'Availability', excel: 'Declarations get lost in messages and comments.', schedi: 'Employees submit availability in one place.' },
          { area: 'Shift swaps', excel: 'The manager has to track every agreement manually.', schedi: 'The request goes through the employee and manager.' },
          { area: 'Publishing', excel: 'The file must be sent, fixed and versioned.', schedi: 'The ready schedule reaches the team with a notification.' },
          { area: 'Reports', excel: 'Hours and costs need manual calculations.', schedi: 'PDF and CSV export is available in the app.' },
        ],
        cta: 'Compare Schedi with Excel',
      },
      roi: {
        eyebrow: 'Calculator',
        title1: 'How much are you losing',
        title2: 'without Schedi?',
        employees: 'Number of employees',
        hours: 'Hours on scheduling per week',
        rate: 'Manager rate (PLN/h)',
        timeLost: 'Time wasted per month',
        costLost: 'Cost to company per month',
        schediCost: 'Schedi costs',
        savings: 'You save per month',
        cta: 'Start saving today',
        ctaSub: 'The result is an estimate to help you calculate manager time cost.',
      },
      pricing: {
        title: 'Simple plan.',
        subtitle: 'Zero surprises.',
        desc: 'Pay for what you use. No hidden fees, no contracts.',
        month: 'month',
        planName: 'Standard Plan',
        badge: 'Bestseller',
        upTo4: 'up to 10 employees',
        teamDesc: 'Perfect start for a small team',
        features: {
          schedule: 'Unlimited shift schedule',
          availability: 'Availability management',
          notifications: 'Automatic notifications',
          export: 'PDF and Excel export',
          timeTracking: 'Work time tracking',
          mobile: 'App-like mobile view',
        },
        addons: 'Add-ons',
        extraOrg: 'Additional location',
        extraEmp: 'Additional employee',
        extraOrgDesc: 'Manage multiple locations from one account',
        extraEmpDesc: 'Above 10 people - scale when you want',
        cta: 'Choose plan and start',
        vat: 'Net prices. No contracts. Cancel anytime',
        guarantee: 'No contracts or obligations. Pay as long as you use it. Cancel with one click in settings.',
      },
      testimonials: {
        eyebrow: 'Practical impact',
        title: 'What Schedi organizes in a workplace',
        note: 'Scenario based on a typical shift planning process.',
        items: [
          { title: 'Fewer schedule questions', desc: 'Employees check their schedule from the phone, so the manager does not answer the same messages several times a day.', meta: 'Communication' },
          { title: 'Faster corrections', desc: 'Availability changes, staffing edits and publishing a new version happen in the same panel.', meta: 'Operations' },
          { title: 'Better staffing control', desc: 'The manager sees who can work, where people are missing and which shifts need attention.', meta: 'Planning' },
        ],
      },
      faq: {
        eyebrow: 'FAQ',
        title: 'Frequently asked questions',
        items: [
          { q: 'Do employees need to install an app?', a: 'No. Schedi works in the browser, so employees can check schedules and availability from their phone without installing a mobile app.' },
          { q: 'How long does setup take?', a: 'You can put together your first schedule the same day. Adding employees and collecting availability usually takes just a few minutes.' },
          { q: 'Can I export schedules to PDF or Excel?', a: 'Yes. Schedi lets you export schedules and reports to PDF and Excel (CSV format).' },
          { q: 'Are there any hidden fees or contracts?', a: 'No. You only pay a monthly subscription, with no fixed-term contracts. You can cancel at any time.' },
          { q: 'How much does a larger team cost?', a: 'The Standard Plan (129 PLN/mo) includes 1 manager and up to 10 employees. Each additional person is +8 PLN, an additional location is +20 PLN.' },
          { q: 'Does Schedi work on mobile?', a: 'Yes. The site is fully responsive on mobile devices. Both managers and employees have full access from their smartphone.' },
        ],
      },
      cta: {
        eyebrow: 'Start today',
        title1: 'Start planning smarter.',
        title2: 'Today.',
        subtitle: 'Join businesses that stopped wasting time on Excel and WhatsApp.',
        cta: 'Start here',
        trust1: 'Schedule ready in 3 minutes',
        trust2: 'No contracts',
        trust3: 'Polish support',
      },
      footer: {
        copy: '© 2026 Schedi',
        email: 'biuro@schedi.pl',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        faq: 'FAQ',
        blog: 'Blog',
        contact: 'Contact',
        description: 'Schedi is work schedule software for restaurants, cafes, bars and small shift teams.',
        product: 'Product',
        industries: 'Industries',
        functions: 'Features',
        program: 'Work schedule software',
        restaurant: 'Restaurant schedule',
        cafe: 'Cafe schedule',
        bar: 'Bar schedule',
        hotel: 'Hotel work schedule',
        vsExcel: 'Schedi vs Excel',
        availability: 'Employee availability',
        swaps: 'Shift swaps',
        reports: 'Hour reports',
        company: 'Company',
        detailsTitle: 'Trust and details',
        details: 'For product, billing and data protection questions, contact biuro@schedi.pl. Legal details are available in the terms and privacy policy.',
      },
      seoPages: {
        relatedTitle: 'Related pages',
        program: {
          url: '/program-do-grafikow-pracy',
          breadcrumb: 'Work schedule software',
          metaTitle: 'Work schedule software for hospitality',
          metaDescription: 'Schedi is online work schedule software for restaurants, cafes and small businesses. Plan shifts, collect availability and publish schedules in one place.',
          hero: { badge: 'Work schedule software', title: 'Work schedule software for small teams', subtitle: 'Schedi helps managers build shift schedules, collect employee availability and keep communication organized without Excel.', cta: 'Try for free', secondaryCta: 'See pricing' },
          problem: { title: 'Excel stops working when the schedule starts changing', desc: 'A spreadsheet works for a few employees. With swaps, time off, availability and changes, it becomes easy to lose control of the current version.', items: ['Employee availability lands in different messages.', 'Changes need to be fixed manually in the spreadsheet.', 'Employees ask for the latest schedule version.', 'Hour reports require extra work.'] },
          solution: { title: 'One place for schedules, availability and communication', desc: 'Schedi organizes core shift planning workflows without a heavy rollout or enterprise HR system.', items: [{ title: 'Online shift schedule', desc: 'Create and edit shifts in a clear manager view.' }, { title: 'Employee availability', desc: 'Collect team declarations before building the schedule.' }, { title: 'Notifications and export', desc: 'Publish the schedule, notify the team and export data to PDF or CSV.' }] },
          cta: { title: 'Build your first schedule without Excel', desc: 'Start with a simple plan, invite your team and see how much manual work you can remove from the manager week.', button: 'Start here' },
        },
        restaurant: {
          url: '/grafik-pracy-restauracja',
          breadcrumb: 'Restaurant schedule',
          metaTitle: 'Restaurant work schedule without Excel',
          metaDescription: 'Create restaurant work schedules for kitchen, floor and bar teams. Schedi helps collect availability, plan staffing and approve shift swaps.',
          hero: { badge: 'Restaurant work schedule', title: 'Restaurant work schedule without Excel and phone calls', subtitle: 'Plan kitchen, floor and bar teams in one tool. Schedi helps staff lunch, dinner, weekends and sudden changes.', cta: 'Try it for restaurants', secondaryCta: 'See pricing' },
          problem: { title: 'In hospitality, the schedule changes all the time', desc: 'A weekend, sickness, availability change or swap request can break a finished plan when everything lives in a spreadsheet and chat.', items: ['Servers, kitchen and bar teams have different roles and availability.', 'Weekend shifts need fast manager response.', 'Chat-based swaps are easy to miss.', 'Employees need phone access to the schedule.'] },
          solution: { title: 'Schedi organizes daily restaurant planning', desc: 'The app focuses on what restaurant managers do most often: shifts, corrections and team communication.', items: [{ title: 'Roles and staffing', desc: 'Plan shifts around positions and staffing needs.' }, { title: 'Availability before scheduling', desc: 'See who can work before publishing the rota.' }, { title: 'Controlled shift swaps', desc: 'Swap requests follow an approval process instead of disappearing in messages.' }] },
          cta: { title: 'Replace the spreadsheet with a simple online schedule', desc: 'Schedi is built for managers who want to publish schedules faster and reduce calls about shifts.', button: 'Start for free' },
        },
        excel: {
          url: '/schedi-vs-excel',
          breadcrumb: 'Schedi vs Excel',
          metaTitle: 'Schedi vs Excel for work schedules',
          metaDescription: 'Compare Schedi and Excel for work scheduling. See differences in availability, shift swaps, schedule publishing and reports.',
          hero: { badge: 'Schedi vs Excel', title: 'Schedi vs Excel for work schedules', subtitle: 'Excel is good at the start. Schedi starts winning when you need availability, notifications, swaps and export without manual version control.', cta: 'Test Schedi', secondaryCta: 'See pricing' },
          problem: { title: 'A spreadsheet is not a scheduling process', desc: 'Excel stores a table, but it does not collect availability, approve swaps or tell employees that a new version is ready.', items: ['Every edit creates a risk of working on the old version.', 'Swaps require manual confirmation.', 'Availability needs to be copied from messages.', 'Hour reports depend on correct formulas.'] },
          solution: { title: 'Schedi adds process around the schedule', desc: 'Instead of replacing one spreadsheet with another, Schedi connects the schedule with availability, team data, notifications and export.', items: [{ title: 'One current schedule', desc: 'The team sees the current version, and the manager edits it in the app.' }, { title: 'Fewer manual agreements', desc: 'Availability and swaps have their own place and status.' }, { title: 'Export without copying', desc: 'PDF and CSV help pass data onward without copying tables.' }] },
          cta: { title: 'Check whether Excel still works for you', desc: 'If scheduling takes too much time or needs constant fixes, test Schedi with a real team.', button: 'Try for free' },
        },
        cafe: {
          url: '/grafik-dla-kawiarni',
          breadcrumb: 'Cafe schedule',
          metaTitle: 'Work schedule for cafes and baristas',
          metaDescription: 'Schedi helps build cafe work schedules, collect barista availability and publish shifts without spreadsheets or scattered messages.',
          hero: { badge: 'Cafe schedule', title: 'Cafe work schedule in one clear view', subtitle: 'Plan baristas, morning, afternoon and weekend shifts in one simple online tool.', cta: 'Try it for cafes', secondaryCta: 'See pricing' },
          problem: { title: 'A cafe needs a flexible schedule', desc: 'Cafe traffic changes throughout the day, and availability for students, baristas and part-time staff can change every week.', items: ['Availability lands in many chats and notes.', 'Weekend shifts need quick coverage.', 'A new schedule version gets buried in messages.', 'The manager loses time answering schedule questions.'] },
          solution: { title: 'Schedi organizes cafe scheduling', desc: 'Plan staffing, collect availability and give the team access to the current schedule in one place.', items: [{ title: 'Barista availability', desc: 'Collect declarations before planning the week.' }, { title: 'Shifts without spreadsheets', desc: 'Edit mornings, afternoons and weekends in a clear view.' }, { title: 'Publishing for the team', desc: 'Employees see the current schedule from their phone.' }] },
          cta: { title: 'Build your cafe schedule online', desc: 'Test Schedi with your team and see how many schedule messages you can remove from the week.', button: 'Start here' },
        },
        bar: {
          url: '/grafik-dla-baru',
          breadcrumb: 'Bar schedule',
          metaTitle: 'Work schedule for bars and evening shifts',
          metaDescription: 'Create bar work schedules, plan evenings and weekends, collect availability and keep shift swaps under control in Schedi.',
          hero: { badge: 'Bar schedule', title: 'Work schedule for bars, weekends and evenings', subtitle: 'Schedi helps plan bartenders, floor staff and seasonal shifts without rewriting spreadsheets.', cta: 'Try it for bars', secondaryCta: 'See pricing' },
          problem: { title: 'Evening shifts need fast corrections', desc: 'Bars work at hours where every absence or shift swap quickly affects staffing.', items: ['Weekend shifts are most sensitive to missing people.', 'Chat-based swaps are hard to control.', 'Team availability changes from week to week.', 'The manager needs one current schedule version.'] },
          solution: { title: 'One schedule for the whole bar', desc: 'Schedi connects shifts, availability and swap requests in one process, without manual version tracking.', items: [{ title: 'Evening staffing', desc: 'Plan shifts around your real opening hours.' }, { title: 'Swaps with status', desc: 'Each request has an owner, stage and manager decision.' }, { title: 'Schedule export', desc: 'Share a ready plan as PDF or CSV without copying tables.' }] },
          cta: { title: 'Replace chat with a controlled schedule', desc: 'If weekend scheduling needs constant corrections, test Schedi on a real work week.', button: 'Try for free' },
        },
        hotel: {
          url: '/grafik-pracy-hotel',
          breadcrumb: 'Hotel work schedule',
          metaTitle: 'Hotel work schedule for reception and service teams',
          metaDescription: 'Schedi helps plan hotel work schedules for reception, service and shift teams. Collect availability and publish the schedule online.',
          hero: { badge: 'Hotel work schedule', title: 'Hotel work schedule in one view', subtitle: 'Plan reception, service and hourly teams without searching for the current schedule in spreadsheets.', cta: 'Try it for hotels', secondaryCta: 'See pricing' },
          problem: { title: 'A hotel needs continuous staffing', desc: 'Reception, service and duty shifts need a predictable plan, while availability changes can quickly complicate the schedule.', items: ['Different roles need separate staffing control.', 'Morning, afternoon and night shifts need to fit together.', 'Absences require fast coverage.', 'The team needs access to the current schedule.'] },
          solution: { title: 'Schedi simplifies hotel shift planning', desc: 'The manager sees the team, availability and schedule in one place, while employees can check their shifts from a phone.', items: [{ title: 'Roles and positions', desc: 'Plan staffing around reception and service needs.' }, { title: 'Current schedule', desc: 'Reduce questions about the latest schedule version.' }, { title: 'Hour reports', desc: 'Export data for further settlement without manual copying.' }] },
          cta: { title: 'Organize your hotel schedule online', desc: 'Start with one team and see whether Schedi fits your shift planning process.', button: 'Start here' },
        },
        availability: {
          url: '/funkcje/dostepnosc-pracownikow',
          breadcrumb: 'Employee availability',
          metaTitle: 'Employee availability in work scheduling',
          metaDescription: 'Collect employee availability before building the schedule. Schedi helps managers plan shifts without searching for declarations in messages.',
          hero: { badge: 'Employee availability', title: 'Employee availability before the schedule is built', subtitle: 'Collect team declarations in one place and plan shifts based on current information.', cta: 'See availability in Schedi', secondaryCta: 'See pricing' },
          problem: { title: 'The schedule starts with availability', desc: 'When availability lives in messages, notes and manager memory, every schedule carries more risk of mistakes.', items: ['Employee declarations are easy to miss.', 'Partial availability needs manual checking.', 'Shifts need corrections after publishing.', 'The manager lacks one view before planning.'] },
          solution: { title: 'Schedi collects declarations in one place', desc: 'Employees enter when they can work, and the manager sees availability before assigning shifts.', items: [{ title: 'Daily availability', desc: 'See who can work on a specific date.' }, { title: 'Weekly patterns', desc: 'Organize recurring team availability.' }, { title: 'Fewer corrections', desc: 'Plan shifts with less risk of conflicts.' }] },
          cta: { title: 'Collect availability in one place', desc: 'Move employee declarations from chat into one work schedule planning process.', button: 'Try Schedi' },
        },
        swaps: {
          url: '/funkcje/zamiana-zmian',
          breadcrumb: 'Shift swaps',
          metaTitle: 'Employee shift swaps under manager control',
          metaDescription: 'Handle shift swaps in Schedi. An employee submits a request, the other person responds, and the manager approves the change in one process.',
          hero: { badge: 'Shift swaps', title: 'Shift swaps without losing agreements', subtitle: 'Swap requests follow a clear process instead of disappearing in chat and private messages.', cta: 'See swaps in Schedi', secondaryCta: 'See pricing' },
          problem: { title: 'Chat swaps lose context fast', desc: 'When employees agree outside the schedule, the manager has to manually check who agreed to what and when.', items: ['It is unclear who accepted the change.', 'The manager updates the schedule manually.', 'The old schedule version stays in circulation.', 'There is no decision history for the swap.'] },
          solution: { title: 'Schedi gives swaps a status and process', desc: 'A request goes through the employee and manager, so the schedule can be updated without tracking messages by hand.', items: [{ title: 'Swap request', desc: 'An employee starts the change from the app.' }, { title: 'Other employee approval', desc: 'The swap has a clear response before the manager decides.' }, { title: 'Manager decision', desc: 'Final approval stays in a controlled process.' }] },
          cta: { title: 'Organize swaps in your team', desc: 'Replace manual agreements with a process the manager can approve without searching messages.', button: 'Try for free' },
        },
        reports: {
          url: '/funkcje/raporty-godzin',
          breadcrumb: 'Hour reports',
          metaTitle: 'Work hour reports and schedule export',
          metaDescription: 'Export schedules and work hour reports to PDF and CSV. Schedi helps managers pass data onward without manually rewriting spreadsheets.',
          hero: { badge: 'Hour reports', title: 'Work hour reports without copying data', subtitle: 'Export schedules, hours and data for further settlement without manually copying tables.', cta: 'See reports in Schedi', secondaryCta: 'See pricing' },
          problem: { title: 'Spreadsheet reports need extra work', desc: 'When schedules and shifts are corrected manually, hour export depends on the current table and correct formulas.', items: ['Data needs to be copied between files.', 'Formulas are easy to break during corrections.', 'Schedule PDFs are created manually.', 'The manager loses time organizing the report.'] },
          solution: { title: 'Schedi helps pass data onward', desc: 'After building the schedule, you can export data in a format that is easier to share with the team or use for further settlement.', items: [{ title: 'PDF export', desc: 'Prepare a readable schedule for sharing.' }, { title: 'CSV export', desc: 'Pass data onward without manual rewriting.' }, { title: 'Better hour control', desc: 'Analyze the schedule and staffing in one tool.' }] },
          cta: { title: 'Export schedules without manual work', desc: 'See how Schedi simplifies hour reporting for small shift teams.', button: 'Start here' },
        },
      },
      seoPageFaq: {
        program: { title: 'Common questions about work schedule software', items: [{ q: 'What is work schedule software?', a: 'It is an online tool for creating, publishing and updating shift schedules. In Schedi, managers can also collect availability, handle swaps and export data.' }, { q: 'Does Schedi replace Excel?', a: 'Yes, for shift planning. Schedi is not a spreadsheet, but a process around the schedule: availability, team data, publishing, notifications and export live in one place.' }, { q: 'Can I start with one team?', a: 'Yes. Schedi is prepared for small teams and can grow with the business without a heavy IT rollout.' }] },
        restaurant: { title: 'Common questions about restaurant schedules', items: [{ q: 'Is Schedi suitable for restaurants with kitchen and floor teams?', a: 'Yes. You can plan different roles and teams, while employees access the current schedule from their phones.' }, { q: 'Can employees submit availability?', a: 'Yes. Availability is one of Schedi core elements and helps build the schedule before publishing.' }, { q: 'Do shift swaps need manager approval?', a: 'Yes. Swaps can follow an approval process so the manager keeps control over staffing.' }] },
        excel: { title: 'Common questions about Schedi vs Excel', items: [{ q: 'When does Excel stop being enough?', a: 'Most often when frequent swaps, different employee availability, multiple roles and fast publication of the current schedule become part of the process.' }, { q: 'Can Schedi export data to a spreadsheet?', a: 'Yes. You can export data to CSV if you need to pass it onward or connect it with another process.' }, { q: 'Do I need to move the whole process immediately?', a: 'No. You can start with one team and test Schedi on a real work schedule.' }] },
        cafe: { title: 'Common questions about cafe schedules', items: [{ q: 'Does Schedi work for part-time baristas?', a: 'Yes. Employee availability can be collected before the schedule is built, which helps flexible teams.' }, { q: 'Does the schedule work on a phone?', a: 'Yes. Managers and employees can use Schedi in a mobile browser.' }, { q: 'Can I export the cafe schedule?', a: 'Yes. Schedi supports exporting schedules and data to PDF and CSV.' }] },
        bar: { title: 'Common questions about bar schedules', items: [{ q: 'Does Schedi help with weekend shifts?', a: 'Yes. You can plan evening and weekend staffing and respond faster to availability changes.' }, { q: 'Are shift swaps visible to the manager?', a: 'Yes. Swap requests have a status and can require manager approval.' }, { q: 'Does the team see the current schedule?', a: 'Yes. Employees can check the current schedule from their phone.' }] },
        hotel: { title: 'Common questions about hotel schedules', items: [{ q: 'Does Schedi handle different hotel roles?', a: 'Yes. You can plan the team around roles and staffing needs.' }, { q: 'Is Schedi an HR system?', a: 'No. Schedi focuses on work schedules, availability, swaps and basic reports for shift teams.' }, { q: 'Can I start with reception only?', a: 'Yes. You can introduce Schedi for one team first and expand usage later.' }] },
        availability: { title: 'Common questions about employee availability', items: [{ q: 'How does an employee submit availability?', a: 'The employee uses the browser app and enters when they can work. The manager sees declarations before building the schedule.' }, { q: 'Can partial availability be marked?', a: 'Yes. Schedi supports full availability, partial availability and unavailability.' }, { q: 'Does availability reduce corrections?', a: 'It helps limit mistakes because the manager plans with declarations collected in one place.' }] },
        swaps: { title: 'Common questions about shift swaps', items: [{ q: 'Who approves a shift swap?', a: 'The process can include the other employee response and the manager decision to keep staffing under control.' }, { q: 'Do swaps replace chat agreements?', a: 'Yes. Instead of searching messages, the manager sees the request and its status in the app.' }, { q: 'Can an employee give away a shift?', a: 'Schedi supports giving away a shift and a classic swap between employees.' }] },
        reports: { title: 'Common questions about hour reports', items: [{ q: 'What exports does Schedi support?', a: 'Schedi supports PDF and CSV export, making it easier to share the schedule or pass data onward.' }, { q: 'Do reports replace payroll software?', a: 'No. Reports help organize schedule data, but they do not replace a full payroll or HR system.' }, { q: 'Does export require manual rewriting?', a: 'No. Data comes from the schedule in the app, so you reduce manual table copying.' }] },
      },
      contact: {
        title: 'Contact Us',
        desc: 'Have questions? We are here to help your business grow.',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        addressLabel: 'Address',
        form: {
          name: 'Full Name',
          email: 'Email Address',
          message: 'Message',
          placeholder: 'How can we help you?',
          send: 'Send Message'
        }
      }
    }
  },
  ua: {
    joinNotice: {
      message: 'Приєднано до команди!',
    },
    menu: {
      schedule: 'Графік',
      shiftPlan: 'План змін',
      dashboard: 'Дашборд',
      team: 'Команда',
      billing: 'Платежі',
      subscription: 'Підписка',
      settings: 'Налаштування',
      mySchedule: 'Мій графік',
      teamSchedule: 'Графік команди',
      myTeam: 'Моя команда',
      availability: 'Доступність',
      logout: 'Вийти',
      shiftSwaps: 'Обміни змінами',
      shiftSwapsMobile: 'Обміни',
      chat: 'Чат',
    },
    cookieConsent: {
      title: 'Конфіденційність і cookies',
      subtitle: 'Ви вирішуєте, чи можемо ми вимірювати ефективність сайту.',
      description: 'Ми використовуємо cookies, необхідні для роботи Schedi, а за вашою згодою також аналітичні cookies Google Analytics. Аналітика допомагає нам розуміти, які публічні сторінки та форми працюють найкраще. Ми не використовуємо рекламні cookies або ремаркетинг.',
      necessaryTitle: 'Необхідні cookies',
      necessaryDescription: 'Вони підтримують вхід, безпеку, мову інтерфейсу та режим відображення. Вони завжди активні.',
      analyticsTitle: 'Аналітичні cookies',
      analyticsDescription: 'Вони дозволяють вимірювати відвідування публічних сторінок, джерела трафіку та базові події конверсії в Google Analytics.',
      alwaysActive: 'Завжди активні',
      acceptAll: 'Прийняти всі',
      reject: 'Відхилити',
      customize: 'Налаштувати',
      save: 'Зберегти вибір',
      back: 'Назад',
      close: 'Закрити налаштування cookies',
      footerLink: 'Налаштування cookies',
    },
    chat: {
      title: 'Чат команди',
      noChannel: 'Немає каналу для цієї команди.',
      sendPlaceholder: 'Напишіть повідомлення… (@імʼя для згадки)',
      send: 'Надіслати',
      loadingMessages: 'Завантаження повідомлень…',
      loadMore: 'Завантажити старіші',
      errorSend: 'Не вдалося надіслати повідомлення.',
      upgradeTitle: 'Чат доступний у плані Pro',
      upgradeDesc: 'Активуйте підписку, щоб користуватися командним чатом.',
      newMessages: 'Нові повідомлення',
    },
    actions: {
      generate: 'Генерувати',
      generateRecurring: 'Створити постійні',
      generateRecurringInfo: 'Створює одразу кілька змін за повторюваним тижневим шаблоном у вибраному діапазоні дат (макс. 3 місяці).',
      filter: 'Фільтр',
      send: 'Надіслати',
      revoke: 'Відкликати',
      approve: 'Підтвердити',
      unlock: 'Розблокувати',
      invite: 'Запросити',
      inviteEmployee: 'Запросити працівника',
      month: 'Місяць',
      week: 'Тиждень',
      goToShiftPlan: 'Перейти до плану змін',
      autoAssign: 'Авто-призначити',
      autoAssignShort: 'Авто',
      autoAssignInfo: 'Автоматично підбирає працівників на відкриті зміни на основі їхньої доступності та призначених ролей.',
    },
    views: {
      staffing: 'Заповнення на цей тиждень',
      workload: 'Навантаження працівників',
      selectTeam: 'Виберіть команду'
    },
    dashboard: {
      title: 'Стратегічний огляд команди',
      subtitle: 'Керуйте працівниками у ваших локаціях',
      allShifts: 'Всі зміни',
      allShiftsDesc: 'Кількість запланованих змін',
      scheduleCoverage: 'Покриття графіка',
      scheduleCoverageDesc: 'Відсоток призначених змін',
      overtime: 'Надурочні',
      overtimeDesc: 'Працівники понад норму',
      teamMembers: 'Працівники команди',
      teamMembersDesc: 'Підсумок годин за обраний період',
      weeks: 'тиж.',
      hours: 'год.',
      yourTeams: 'Ваші команди',
      scheduleExecution: 'Виконання графіка',
      shiftsFilled: 'змін заповнено',
      of: 'з',
      shiftsInMonth: 'Зміни за місяць',
      shiftsInWeek: 'Зміни за тиждень',
      unfilled: 'незаповнених',
      overtimeAlerts: 'Сповіщення про надурочні',
      overTarget: 'Працівники понад свої цілі',
      allNormal: 'Всі в нормі',
      employeeWorkload: 'Навантаження працівників',
      rankingByHours: 'За годинами —',
      noActiveEmployees: 'Немає активних працівників у команді',
      inviteMembersStats: 'Запросіть членів команди, щоб побачити статистику',
      employee: 'Працівник',
      hoursCol: 'Години',
      payoutEst: 'Виплата (орієнтовно)',
      targetYou: 'Ціль / Ти',
      workloadPercentage: 'Відсоток цільового навантаження',
      mostHours: 'Найбільше годин',
      shiftsCount: 'змін',
      hoursPerWeek: 'г/тиж',
      onTheEdge: 'На межі',
      noShifts: 'Немає змін',
      ok: 'OK'
    },
    shiftPlan: {
      draft: 'Чернетка',
      pending: 'Очікує затвердження',
      approved: 'Затверджено',
      rejected: 'Потребує доопрацювання',
      shiftsList: 'Список змін',
      filterEmployees: 'Фільтрувати співробітників',
      clearFilters: 'Очистити фільтри',
      noEmployeesAlert: 'Немає працівників. Додайте їх у розділі Команда.',
      lockedMonthAlert: 'Місяць заблокований (затверджений). Редагування неможливе.',
      pendingMonthAlert: 'Місяць очікує затвердження. Деякі дії можуть бути заблоковані.',
      noShiftsFiltered: 'Жодної зміни за обраними фільтрами.',
      allPositions: 'Всі посади',
      sendForApprovalText: 'Бажаєте відправити розклад на цей місяць на затвердження?',
      sendForApprovalConfirm: 'Так, відправити',
      cancel: 'Скасувати'
    },
    autoAssign: {
      title: 'Авто-призначення змін',
      subtitle: 'Підберіть працівників на відкриті зміни на основі доступності та ролей',
      summaryOpenShifts: 'відкритих змін',
      summaryAssigned: 'призначених',
      summaryUnassigned: 'непризначених',
      summaryNoAvailData: 'без даних доступності',
      proposalsTitle: 'Пропозиції призначень',
      unassignedTitle: 'Непризначені зміни',
      legendTitle: 'Легенда попереджень',
      applyBtn: 'Застосувати призначення',
      noOpenTitle: 'Немає відкритих змін для призначення.',
      noOpenDesc: 'Всі зміни цього місяця вже зайняті.',
      colDate: 'Дата',
      colHours: 'Години',
      colEmployee: 'Працівник',
      colRole: 'Роль',
      colWarnings: 'Попередження',
      colReason: 'Причина',
      warnUnknownAvailability: 'Немає даних доступності',
      warnPartialMismatch: 'Часткова доступність',
      warnNoRoleMatch: 'Немає кандидатів з роллю',
      warnNoCandidates: 'Немає кандидатів',
      warnTargetExceeded: 'Перевищено ціль',
    },
    staffRoles: {
      title: 'Посадові ролі',
      rolesCountOne: 'роль',
      rolesCountFew: 'ролі',
      rolesCountMany: 'ролей',
      definedRoles: 'Визначені ролі',
      noRolesDefined: 'Немає визначених ролей. Додайте першу нижче.',
      roleNamePlaceholder: 'Назва ролі (напр. Бариста)',
      addRole: 'Додати роль',
      deleteRole: 'Видалити роль',
      assignRolesTitle: 'Призначення ролей працівникам',
      assignRole: 'Призначити роль',
      removeRole: 'Видалити роль',
      requiredRole: "Обов'язкова роль",
      noRoleRequired: 'Немає (будь-яка роль)',
      confirmDeleteTitle: 'Видалити роль?',
      confirmDeleteDesc: 'Роль буде видалена з профілів усіх працівників. Цю операцію не можна скасувати.',
      deleteConfirmBtn: 'Видалити роль',
      deleting: 'Видалення...',
    },
    settings: {
      title: 'Налаштування',
      subtitle: 'Налаштуйте програму відповідно до ваших уподобань',
      language: 'Мова додатка',
      appearance: 'Вигляд',
      darkMode: 'Темний режим',
      darkModeDesc: 'Перемикання між світлою та темною темами',
      finance: 'Фінанси',
      hourlyRate: 'Погодинна ставка',
      hourlyRateDesc: 'Ставка для розрахунку орієнтовної зарплати'
    },
    role: {
      manager: 'Менеджер',
      employee: 'Працівник'
    },
    notifications: {
      title: 'Сповіщення',
      markAllRead: 'Позначити всі як прочитані',
      empty: 'Немає нових сповіщень',
      justNow: 'Щойно',
      minutesAgo: 'хв. тому',
      hoursAgo: 'год. тому',
      daysAgo: 'днів тому',
      deleteAll: 'Видалити всі'
    },
    shiftSwap: {
      pageTitle: 'Обміни змінами',
      pageSubtitle: 'Керуйте запитами працівників на обмін або передачу змін.',
      waitingForYou: 'Очікує на Вас',
      totalRequests: 'Всього запитів',
      pending: 'Очікуючі',
      all: 'Всі',
      noPendingTitle: 'Немає очікуючих запитів',
      noRequestsTitle: 'Немає запитів',
      noPendingDesc: 'Всі запити були розглянуті.',
      noRequestsDesc: 'Працівники ще не подали жодних запитів.',
      statusPendingEmployee: 'Очікує на працівника',
      statusPendingManager: 'Очікує на Вас',
      statusApproved: 'Затверджено',
      statusRejected: 'Відхилено',
      statusCancelled: 'Скасовано',
      badgeWaitingEmployee: 'Очікує відповіді',
      badgeWaitingManager: 'Очікує менеджера',
      giveAway: 'Передача',
      giveAwayFull: 'Передача зміни',
      swap: 'Обмін',
      swapFull: 'Обмін змінами',
      shiftUnavailable: 'Зміна недоступна',
      shiftUnknown: 'Невідома зміна',
      shiftA: 'Зміна А',
      shiftB: 'Зміна Б',
      unknownMember: 'Невідомий',
      withLabel: 'з:',
      decide: 'Розглянути',
      applied: 'Застосовано',
      rejectedLabel: 'Відхилено',
      requiresDecision: 'Потребує вашого рішення',
      giveAwayWarning: 'Працівник хоче передати цю зміну. Затвердження видалить призначення — зміна стане вільною.',
      employeeNote: 'Нотатка працівника:',
      managerNote: 'Ваша нотатка (необов\'язково)',
      managerNotePlaceholder: 'Напр. причина відмови або коментар...',
      submittedAt: 'Подано:',
      reject: 'Відхилити',
      approve: 'Затвердити',
      processing: 'Обробка...',
      requestTitle: 'Запит на обмін',
      activeRequestTitle: 'Ця зміна вже має активний запит',
      activeRequestDesc: 'Зачекайте, поки попередній запит буде розглянутий, або скасуйте його.',
      close: 'Закрити',
      selectType: 'Виберіть тип запиту:',
      giveAwayOptionTitle: 'Передати зміну',
      giveAwayOptionDesc: 'Менеджер вирішить, хто її візьме.',
      swapOptionTitle: 'Обмінятися змінами',
      swapOptionDesc: 'Виберіть колегу та його зміну для обміну.',
      selectColleagueStep: '1. Виберіть колегу',
      noColleagues: 'Немає інших активних членів команди.',
      noColleagueShifts: 'Цей працівник не має призначених змін для обміну.',
      back: 'Назад',
      next: 'Далі',
      yourShift: 'Ваша зміна:',
      noteOptional: 'Нотатка (необов\'язково)',
      notePlaceholder: 'Напр. сімейна відпустка, лікарський візит...',
      giveAwayInfo: 'Менеджер побачить ваш запит і вирішить, хто візьме зміну.',
      swapInfo: 'Колега повинен спочатку прийняти пропозицію, а потім менеджер затвердить обмін.',
      sending: 'Надсилання...',
      sendRequest: 'Надіслати запит',
      selectColleagueError: 'Виберіть колегу та його зміну для обміну.',
      swapProposal: 'Пропозиція обміну',
      wantsToSwap: 'хоче обмінятися змінами',
      colleagueDefault: 'Колега',
      colleagueShift: 'Зміна колеги',
      yourShiftLabel: 'Ваша зміна',
      messageFrom: 'Повідомлення від',
      respondInfo: 'Після вашого прийняття менеджер повинен ще затвердити обмін, перш ніж він стане офіційним.',
      accept: 'Прийняти'
    },
    team: {
      inviteModal: {
        tabEmail: 'Через email',
        tabLink: 'Через посилання',
        closeButton: 'Закрити',
      },
      inviteLink: {
        sectionTitle: 'Посилання для приєднання до команди',
        sectionSubtitle: 'Кожен, хто має це посилання, може приєднатися як працівник, поки ви його не відкличете.',
        loading: 'Завантаження посилання...',
        copy: 'Копіювати',
        copied: 'Скопійовано!',
        regenerate: 'Регенерувати',
        regenerateConfirm: 'Регенерація анулює поточне посилання — усі, хто його має, більше не зможуть приєднатися. Продовжити?',
        revoke: 'Відкликати',
        activate: 'Активувати',
        revokedNotice: 'Посилання відкликано — ніхто не може приєднатися через нього.',
        error: 'Не вдалося керувати посиланням. Спробуйте ще раз.',
      },
    },
    auth: {
      forgotPassword: {
        title: 'Скидання пароля',
        subtitle: 'Введіть адресу email, і ми надішлемо вам посилання для скидання',
        sendButton: 'Надіслати посилання',
        sending: 'Надсилання...',
        successMessage: 'Перевірте поштову скриньку (включаючи спам) — ми надіслали вам посилання.',
        backToLogin: 'Назад до входу',
        errorGeneric: 'Не вдалося надіслати email. Спробуйте ще раз.',
      },
      resetPassword: {
        title: 'Новий пароль',
        subtitle: 'Встановіть новий пароль для вашого облікового запису',
        newPassword: 'Новий пароль',
        confirmPassword: 'Підтвердіть пароль',
        submitButton: 'Змінити пароль',
        submitting: 'Збереження...',
        errorMismatch: 'Паролі не збігаються',
        errorShort: 'Пароль повинен містити не менше 6 символів',
        errorGeneric: 'Не вдалося змінити пароль. Спробуйте ще раз.',
        invalidLink: 'Посилання для скидання пароля недійсне або застаріло',
      },
      forgotPasswordLink: 'Забули пароль?',
      passwordResetSuccess: 'Пароль змінено. Увійдіть.',
      continueWithGoogle: 'Продовжити з Google',
      orSeparator: 'або',
      login: {
        tagline: 'Керуйте графіком команди в одному місці',
        title: 'З поверненням',
        subtitle: 'Увійдіть у свій обліковий запис',
        emailLabel: 'Email',
        passwordLabel: 'Пароль',
        submitButton: 'Увійти',
        resendButton: 'Надіслати нове посилання для підтвердження',
        resendRetry: 'Спробуйте ще раз через {time}',
        noAccount: 'Немає облікового запису?',
        registerLink: 'Зареєструватися',
        errorUnexpected: 'Виникла неочікувана помилка. Спробуйте ще раз.',
        errorResendEmailRequired: 'Введіть адресу email, щоб повторно надіслати посилання для підтвердження.',
        errorResendRateLimit: 'Перевищено ліміт спроб на сервері. Спробуйте ще раз трохи пізніше.',
        errorResendGeneric: 'Не вдалося надіслати email: {message}',
        successResend: 'Нове посилання для підтвердження надіслано! Перевірте пошту (також папку СПАМ).',
        successConfirmed: 'Email підтверджено! Увійдіть, щоб продовжити.',
        errorLinkExpired: 'Термін дії посилання для підтвердження закінчився. Введіть свій email нижче та натисніть "Надіслати ще раз", щоб отримати нове посилання.',
        errorVerification: 'Помилка перевірки: {desc}',
        invitedGeneric: 'Вас запросили до команди! Увійдіть, щоб приєднатися.',
        invitedWithTeam: 'Вас запросили до команди "{team}"! Увійдіть, щоб приєднатися.',
        joinLinkInvitedWithTeam: 'Ви приєднуєтесь до команди "{team}". Увійдіть, щоб продовжити.',
        joinLinkInvitedGeneric: 'Ви приєднуєтесь до команди. Увійдіть, щоб продовжити.',
      },
      register: {
        tagline: 'Приєднуйтесь до нової ери управління роботою',
        title: 'Створити обліковий запис',
        subtitle: 'Заповніть дані, щоб почати',
        titleInviteSetup: 'Завершіть налаштування',
        subtitleInviteSetup: 'Налаштуйте ім\'я та пароль',
        accountTypeLabel: 'Тип облікового запису',
        accountTypeManager: 'Керівник',
        accountTypeEmployee: 'Працівник',
        nameLabel: 'Ім\'я та прізвище',
        emailLabel: 'Email',
        passwordLabel: 'Пароль',
        submitButton: 'Зареєструватися',
        submitButtonInviteSetup: 'Зберегти і продовжити',
        consentTermsPrefix: 'Приймаю',
        consentTermsLink: 'Умови надання послуг',
        consentPrivacyPrefix: 'Ознайомився(-лась) з',
        consentPrivacyLink: 'Політикою конфіденційності',
        consentPrivacySuffix: 'і надаю згоду на обробку персональних даних',
        haveAccount: 'Вже маєте обліковий запис?',
        loginLink: 'Увійти',
        inviteBannerTitle: 'Запрошення до команди',
        inviteBannerInvitedBy: 'Запросив(ла): {name}',
        joinLinkBannerTitle: 'Приєднання до команди',
        joinLinkBannerLoading: 'Завантаження інформації про команду...',
        successConfigured: 'Обліковий запис налаштовано!',
        successCreated: 'Обліковий запис успішно створено! Перевірте пошту, щоб підтвердити реєстрацію.',
        errorUnexpected: 'Виникла неочікувана помилка. Спробуйте ще раз.',
        seatLimitError: 'Ваш обліковий запис створено, але ця команда наразі заповнена. Зв\'яжіться з керівником або спробуйте пізніше.',
        seatLimitRetry: 'Спробувати ще раз',
        wrongAccountTitle: 'Це запрошення для іншого облікового запису',
        wrongAccountBody: 'Ви увійшли як {name} ({email}). Щоб скористатися цим запрошенням, вийдіть і зареєструйтесь або увійдіть на потрібний обліковий запис.',
        wrongAccountLogout: 'Вийти',
      },
      joinTeam: {
        loading: 'Завантаження запрошення...',
        invalidTitle: 'Посилання-запрошення недійсне',
        invalidBody: 'Це посилання для приєднання до команди неактивне або не існує. Попросіть керівника надати нове посилання.',
        backHome: 'Повернутися на головну',
        title: 'Запрошення до команди {team}',
        cta: 'Приєднатися як працівник',
        alreadyHaveAccount: 'Вже маєте обліковий запис? Увійти',
      },
    },
    billing: {
      pageTitle: 'Керування підпискою',
      currentPlan: 'Поточний план',
      usage: 'Використання',
      addons: 'Керування доповненнями',
      nextCharge: 'Наступний рахунок',
      renewal: 'Наступне поновлення',
      teams: 'Команди',
      employees: 'Працівники',
      status: {
        active: 'Активна',
        trialing: 'Пробний період',
        past_due: 'Проблема з оплатою',
        canceled: 'Скасована',
      },
      extraTeam: 'Додаткова команда',
      extraSeat: 'Додаткове місце',
      perMonth: 'зл/міс',
      teamLimitReached: 'Досягнуто ліміт команд. Придбайте додаткову команду у вкладці Підписка.',
      seatLimitReached: 'Досягнуто ліміт працівників. Придбайте додаткові місця у вкладці Підписка.',
      teamsInUse: 'Видаліть зайві команди перед зниженням плану.',
      seatsInUse: 'Видаліть зайвих працівників або запрошення перед зниженням плану.',
      addonSaved: 'Зміну збережено. Рахунок буде оновлено.',
      paymentFailed: 'Проблема з оплатою. Оновіть дані картки, щоб зберегти доступ до Schedi.',
      updateCard: 'Оновити картку →',
      dangerZone: 'видалення облікового запису',
      deleteAccount: 'Видалити акаунт',
      deleteConfirmPhrase: 'ВИДАЛИТИ МІЙ АКАУНТ',
      deleteError: 'Помилка під час видалення акаунту. Зверніться до служби підтримки.',
      addonError: 'Помилка під час зміни доповнення. Спробуйте ще раз.',
      stripeSecured: 'Платежі безпечно обробляються через Stripe',
      manageInPortal: 'Керувати в порталі Stripe',
      basePlan: 'Базовий план',
      addonConfirmAdd: 'Додати',
      addonConfirmRemove: 'Видалити',
      addonAccessNow: 'Доступ від: зараз',
      addonEndOfPeriod: 'Зміна набере чинності: кінець поточного періоду',
      addonNewBill: 'Новий місячний рахунок',
      addonNewLimit: 'Новий ліміт',
      addonConfirmTitle: 'Підтвердіть зміну',
      addonCancelBtn: 'Скасувати',
      addonConfirmBtn: 'Підтвердити',
      reviewChanges: 'Переглянути зміни',
      cancelPending: 'Скасувати зміни',
      currentCost: 'Поточний рахунок',
      applying: 'Застосовується...',
      deleteAccountTitle: 'Видалити акаунт',
      deleteAccountConsequences: 'Видалення акаунту є незворотним. Вашу підписку буде скасовано. Команду буде видалено, але акаунти працівників залишаться для них доступними. Фінансові дані зберігатимуться протягом 5 років.',
      deleteAccountConsequencesEmployee: 'Видалення акаунту є незворотним. Ваші дані буде видалено і вас буде виключено з усіх команд. Цю операцію неможливо скасувати.',
      deleteTypePlaceholder: 'Введіть: ВИДАЛИТИ МІЙ АКАУНТ',
      deleteSubmitBtn: 'Видалити мій акаунт',
    },
    landing: {
      nav: { features: 'Функції', howItWorks: 'Як це працює', pricing: 'Ціни', faq: 'FAQ', blog: 'Blog', contact: 'Контакт', login: 'Увійти', start: 'Почати тут', app: 'До програми' },
      a11y: { goHome: 'Schedi - перейти на головну', selectLanguage: 'Вибрати мову', toggleTheme: 'Перемкнути тему', openMenu: 'Відкрити меню', closeMenu: 'Закрити меню' },
      seo: {
        title: 'Програма для графіків роботи для ресторанів і гастрономії',
        description: 'Schedi - це програма для графіків роботи для ресторанів, кавʼярень і барів. Створюйте зміни, збирайте доступність і затверджуйте обміни в одному місці.',
      },
      hero: {
        badge: 'Програма для графіків роботи для гастрономії',
        title1: 'Програма для графіків роботи для ресторанів',
        title2: 'Без Excel.',
        subtitle: 'Створюйте графіки роботи за 3 хвилини, збирайте доступність працівників і затверджуйте обміни змінами без десятків дзвінків. Schedi замінює Excel і WhatsApp для ресторанів, кафе, барів і готелів.',
        cta: 'Спробуйте безкоштовно 30 днів',
        watch: 'Дивитися як це працює',
        app: 'Відкрити додаток',
        trust1: 'Графік готовий за 3 хвилини',
        trust2: 'Підтримка польською',
        trust3: 'Без налаштування ІТ'
      },
      stats: [
        { target: 3, suffix: ' хв', label: 'до першого готового графіка' },
        { target: 30, suffix: ' днів', label: 'безкоштовного тесту, без зобов\'язань' },
        { target: 24, suffix: '/7', label: 'доступ до графіка з телефону' },
        { target: 10, suffix: '', label: 'працівників у стартовому плані' },
      ],
      pain: {
        eyebrow: 'Чи це звучить знайомо?',
        title: 'Планування має бути простим.',
        subtitle: 'Менеджери втрачають години на WhatsApp, виправлення Excel і питання про зміни. Schedi впорядковує цей процес в одному місці.',
        card1: { title: 'WhatsApp та дзвінки', desc: 'Сотні повідомлень про зміну змін, відсутності та питання про графік. Ви витрачаєте час замість управління бізнесом.' },
        card2: { title: 'Excel та помилки', desc: 'Файли для об\'єднання, обміну та виправлення. Одна помилка і весь графік треба переробляти.' },
        card3: { title: 'Відсутність контролю', desc: 'Ви не знаєте хто доступний, хто перевищує норму та скільки коштують понаднормові. Рішення приймаються наосліп.' },
      },
      audience: {
        title: 'Для закладів, де графік змінюється щодня',
        subtitle: 'Schedi допомагає малим і середнім змінним командам швидко планувати персонал, збирати доступність і тримати комунікацію під контролем.',
        items: [
          { title: 'Ресторани', desc: 'Плануйте офіціантів, кухню і бар під обіди, вечері, вихідні та раптові відсутності.', link: 'Графік для ресторану' },
          { title: 'Кавʼярні', desc: 'Збирайте доступність барист і публікуйте графік без питань у кількох чатах.', link: 'Подивитися приклад' },
          { title: 'Бари', desc: 'Закривайте вечори, вихідні та сезонні зміни без ручного переписування таблиць.', link: 'Перевірити функції' },
          { title: 'Готелі та послуги', desc: 'Організуйте рецепцію, сервіс і погодинні команди в одному простому вигляді.', link: 'Познайомитися зі Schedi' },
        ],
      },
      benefits: {
        title: 'Менше ручної роботи. Більше контролю над графіком.',
        subtitle: 'Суть не в красивішій таблиці. Йдеться про менше помилок, швидші рішення і спокійнішу команду.',
        items: [
          { metric: '3 хв', title: 'Швидший старт', desc: 'Перший графік можна підготувати одразу після додавання команди і базових змін.' },
          { metric: '1 панель', title: 'Більше порядку', desc: 'Графік, доступність, ролі, обміни і сповіщення знаходяться в одному місці.' },
          { metric: 'PDF/CSV', title: 'Краща передача даних', desc: 'Експортуйте графіки і звіти без ручного копіювання даних з таблиць.' },
        ],
      },
      bento: {
        eyebrow: 'Можливості',
        title1: 'Один інструмент.',
        title2: 'Все під контролем.',
        schedule: { eyebrow: 'Розумний графік', title: 'Графік, що заповнюється сам', desc: 'Виявлення конфліктів, пропозиції персоналу, повторювані зміни одним кліком.' },
        time: { eyebrow: 'Облік часу', title: 'Облік без Excel', desc: 'Автоматичний підрахунок годин, понаднормових та перерв.' },
        availability: { eyebrow: 'Доступність', title: 'Завжди знаєте хто може прийти', desc: 'Працівники самі вносять доступність у додаток. Ви бачите все в одному вигляді.' },
        team: { eyebrow: 'Команда', title: 'Вся команда в одному місці', desc: 'Ваша команда під контролем. Додайте нову людину за 30 секунд.' },
        reports: { eyebrow: 'Звіти', title: 'Витрати під контролем', desc: 'Експорт PDF та Excel. Аналіз годин, понаднормових та витрат на персонал.' },
        notifications: { eyebrow: 'Комунікація', title: 'Кінець WhatsApp', desc: 'Графік опубліковано. Працівники отримують повідомлення. Зміну прийнято. Менеджер знає одразу.' },
      },
      features: {
        title: 'Все, що вам потрібно',
        subtitle: 'в одній платформі',
        desc: 'Schedi впорядковує планування роботи. Зосередьтеся на розвитку бізнесу, а графік залиште нам.',
        items: {
          team: { title: 'Управління командою', desc: 'Легке додавання працівників, призначення ролей та управління доступністю в реальному часі.' },
          schedule: { title: 'Розумний графік', desc: 'Автоматичне виявлення конфліктів та пропозиції щодо персоналу. Створення повторюваних змін одним кліком.' },
          time: { title: 'Відстеження часу', desc: 'Точний облік робочого часу. Виключення перерв та автоматичний розрахунок понаднормових.' },
          availability: { title: 'Доступність', desc: 'Працівники самі декларують доступність. Система блокує призначення змін у недоступні дні.' },
          reports: { title: 'Звіти та витрати', desc: 'Поточна оцінка вартості змін. Звіти про заповнення графіка та бюджетні сповіщення.' },
          actions: { title: 'Швидкі дії', desc: 'Копіювання тижнів, шаблони змін та масові редагування. Економте години щомісяця.' }
        }
      },
      howItWorks: {
        eyebrow: 'Як це працює',
        title1: 'Готовий графік',
        title2: 'за 3 кроки',
        step1: { title: 'Додайте працівників', desc: 'Створіть команду за кілька хвилин і запросіть працівників e-mail або посиланням.' },
        step2: { title: 'Зберіть доступність', desc: 'Працівники вводять коли можуть працювати. Ви бачите все в одному вигляді без дзвінків кожному.' },
        step3: { title: 'Опублікуйте графік', desc: 'Складіть вручну або використовуйте автозаповнення. Один клік і вся команда отримує повідомлення з готовим графіком.' },
      },
      comparison: {
        title: 'Schedi замість таблиці і чату',
        subtitle: 'Excel підходить на старті. Коли зʼявляються доступність, обміни і кілька ролей, спеціальна програма для графіків починає економити час.',
        headers: { area: 'Область', excel: 'Excel і WhatsApp', schedi: 'Schedi' },
        rows: [
          { area: 'Доступність', excel: 'Декларації губляться в повідомленнях і коментарях.', schedi: 'Працівники подають доступність в одному місці.' },
          { area: 'Обміни змінами', excel: 'Менеджер має вручну стежити за домовленостями.', schedi: 'Запит проходить через працівника і менеджера.' },
          { area: 'Публікація', excel: 'Файл треба надіслати, виправити і контролювати версії.', schedi: 'Готовий графік доходить до команди зі сповіщенням.' },
          { area: 'Звіти', excel: 'Години і витрати треба рахувати вручну.', schedi: 'Експорт PDF і CSV доступний у додатку.' },
        ],
        cta: 'Порівняти Schedi з Excel',
      },
      roi: {
        eyebrow: 'Калькулятор',
        title1: 'Скільки ви втрачаєте',
        title2: 'без Schedi?',
        employees: 'Кількість працівників',
        hours: 'Годин на планування на тиждень',
        rate: 'Ставка менеджера (PLN/год)',
        timeLost: 'Час втрачений на місяць',
        costLost: 'Витрати компанії на місяць',
        schediCost: 'Schedi коштує',
        savings: 'Ви економите на місяць',
        cta: 'Починайте економити сьогодні',
        ctaSub: 'Результат є орієнтовним і допомагає оцінити вартість часу менеджера.',
      },
      pricing: {
        title: 'Простий план.',
        subtitle: 'Нуль сюрпризів.',
        desc: 'Платіть за те, що використовуєте. Жодних прихованих платежів, жодних договорів.',
        month: 'місяць',
        planName: 'План Стандарт',
        badge: 'Бестселер',
        upTo4: 'до 10 працівників',
        teamDesc: 'Ідеальний старт для малої команди',
        features: {
          schedule: 'Необмежений графік змін',
          availability: 'Управління доступністю',
          notifications: 'Автоматичні сповіщення',
          export: 'Експорт у PDF та Excel',
          timeTracking: 'Облік робочого часу',
          mobile: 'Вигляд як додаток на мобільному',
        },
        addons: 'Додатки',
        extraOrg: 'Додаткова локація',
        extraEmp: 'Додатковий працівник',
        extraOrgDesc: 'Керуйте кількома відділеннями з одного акаунту',
        extraEmpDesc: 'Понад 10 осіб - масштабуйтеся коли хочете',
        cta: 'Вибрати план і почати',
        vat: 'Ціни нетто. Без договорів. Скасуйте коли хочете',
        guarantee: 'Без договорів та зобов\'язань. Платіть, поки використовуєте. Скасування одним кліком в налаштуваннях.',
      },
      testimonials: {
        eyebrow: 'Практичний ефект',
        title: 'Що Schedi впорядковує в закладі',
        note: 'Сценарій на основі типового процесу планування змін.',
        items: [
          { title: 'Менше питань про графік', desc: 'Працівник перевіряє графік з телефону, а менеджер не відповідає кілька разів на день на ті самі повідомлення.', meta: 'Комунікація' },
          { title: 'Швидші виправлення', desc: 'Зміна доступності, корекція персоналу і публікація нової версії відбуваються в одній панелі.', meta: 'Операції' },
          { title: 'Кращий контроль персоналу', desc: 'Менеджер бачить хто може працювати, де бракує людей і які зміни потребують реакції.', meta: 'Планування' },
        ],
      },
      faq: {
        eyebrow: 'FAQ',
        title: 'Часті запитання',
        items: [
          { q: 'Чи потрібно працівникам встановлювати додаток?', a: 'Ні. Schedi працює в браузері, тому працівник може перевірити графік і доступність з телефону без встановлення мобільного додатку.' },
          { q: 'Скільки часу займає налаштування?', a: 'Перший графік можна скласти того ж дня. Додавання працівників і збір доступності зазвичай займає кілька хвилин.' },
          { q: 'Чи можу я експортувати графіки до PDF або Excel?', a: 'Так. Schedi дозволяє експортувати графік і звіти до PDF та Excel (у форматі CSV).' },
          { q: 'Чи є якісь приховані платежі або договори?', a: 'Ні. Ви платите лише щомісячну підписку, без договорів на визначений термін. Можна скасувати в будь-який момент.' },
          { q: 'Скільки коштує більша команда?', a: 'План Стандарт (129 PLN/міс.) включає 1 менеджера та до 10 працівників. Кожна наступна особа +8 PLN, додаткова локація +20 PLN.' },
          { q: 'Чи працює Schedi на телефоні?', a: 'Так. Сайт повністю адаптований для мобільних пристроїв. Як менеджери, так і працівники мають повний доступ зі смартфона.' },
        ],
      },
      cta: {
        eyebrow: 'Починайте сьогодні',
        title1: 'Починайте планувати розумніше.',
        title2: 'Вже сьогодні.',
        subtitle: 'Приєднайтеся до компаній, які перестали витрачати час на Excel та WhatsApp.',
        cta: 'Почати тут',
        trust1: 'Графік готовий за 3 хвилини',
        trust2: 'Без договорів',
        trust3: 'Підтримка польською',
      },
      footer: {
        copy: '© 2026 Schedi',
        email: 'biuro@schedi.pl',
        privacy: 'Політика конфіденційності',
        terms: 'Умови використання',
        faq: 'FAQ',
        blog: 'Blog',
        contact: 'Контакт',
        description: 'Schedi - це програма для графіків роботи для ресторанів, кавʼярень, барів і малих змінних команд.',
        product: 'Продукт',
        industries: 'Галузі',
        functions: 'Функції',
        program: 'Програма для графіків роботи',
        restaurant: 'Графік роботи ресторану',
        cafe: 'Графік для кавʼярні',
        bar: 'Графік для бару',
        hotel: 'Графік роботи готелю',
        vsExcel: 'Schedi vs Excel',
        availability: 'Доступність працівників',
        swaps: 'Обмін змінами',
        reports: 'Звіти годин',
        company: 'Компанія',
        detailsTitle: 'Дані і довіра',
        details: 'З питань продукту, оплат і захисту даних пишіть на biuro@schedi.pl. Юридичні дані є в умовах і політиці конфіденційності.',
      },
      seoPages: {
        relatedTitle: 'Повʼязані сторінки',
        program: {
          url: '/program-do-grafikow-pracy',
          breadcrumb: 'Програма для графіків роботи',
          metaTitle: 'Програма для графіків роботи для гастрономії',
          metaDescription: 'Schedi - це онлайн програма для графіків роботи для ресторанів, кавʼярень і малих фірм. Плануйте зміни, збирайте доступність і публікуйте графік в одному місці.',
          hero: { badge: 'Програма для графіків роботи', title: 'Програма для графіків роботи для малих команд', subtitle: 'Schedi допомагає менеджерам створювати графіки змін, збирати доступність працівників і впорядковувати комунікацію без Excel.', cta: 'Спробувати безкоштовно', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'Excel перестає вистачати, коли графік починає змінюватися', desc: 'Для кількох працівників таблиця працює. При обмінах, відпустках, доступності і змінах легко втратити контроль над актуальною версією.', items: ['Доступність працівників потрапляє в різні повідомлення.', 'Зміни треба вручну виправляти в таблиці.', 'Працівники питають про останню версію графіка.', 'Звіти годин потребують додаткової роботи.'] },
          solution: { title: 'Одне місце для графіка, доступності і комунікації', desc: 'Schedi впорядковує основні процеси планування змін без важкого впровадження і без корпоративної HR-системи.', items: [{ title: 'Онлайн графік змін', desc: 'Створюйте і редагуйте зміни в зрозумілому вигляді для менеджера.' }, { title: 'Доступність працівників', desc: 'Збирайте декларації команди перед створенням графіка.' }, { title: 'Сповіщення і експорт', desc: 'Публікуйте графік, інформуйте команду і експортуйте дані до PDF або CSV.' }] },
          cta: { title: 'Створіть перший графік без Excel', desc: 'Почніть з простого плану, запросіть команду і перевірте, скільки ручної роботи можна прибрати з тижня менеджера.', button: 'Почати тут' },
        },
        restaurant: {
          url: '/grafik-pracy-restauracja',
          breadcrumb: 'Графік роботи ресторану',
          metaTitle: 'Графік роботи ресторану без Excel',
          metaDescription: 'Створюйте графік роботи ресторану для кухні, залу і бару. Schedi допомагає збирати доступність, планувати персонал і затверджувати обміни змінами.',
          hero: { badge: 'Графік роботи ресторану', title: 'Графік роботи ресторану без Excel і дзвінків', subtitle: 'Плануйте кухню, зал і бар в одному інструменті. Schedi допомагає закривати обіди, вечері, вихідні та раптові зміни.', cta: 'Спробувати для ресторану', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'У гастрономії графік змінюється постійно', desc: 'Вихідні, хвороба, зміна доступності або прохання про обмін можуть зруйнувати готовий план, якщо все живе в таблиці і чаті.', items: ['Офіціанти, кухня і бар мають різні ролі та доступність.', 'Вихідні зміни потребують швидкої реакції менеджера.', 'Обміни в чаті легко пропустити.', 'Працівникам потрібен доступ до графіка з телефону.'] },
          solution: { title: 'Schedi впорядковує щоденне планування ресторану', desc: 'Додаток фокусується на тому, що менеджер ресторану робить найчастіше: змінах, виправленнях і комунікації з командою.', items: [{ title: 'Ролі і персонал', desc: 'Плануйте зміни з урахуванням посад і потреб закладу.' }, { title: 'Доступність перед графіком', desc: 'Бачте хто може працювати до публікації графіка.' }, { title: 'Обміни під контролем', desc: 'Запити на обмін проходять процес затвердження, а не губляться в повідомленнях.' }] },
          cta: { title: 'Замініть таблицю простим онлайн-графіком', desc: 'Schedi створено для менеджерів, які хочуть швидше публікувати графік і зменшити кількість дзвінків про зміни.', button: 'Почати безкоштовно' },
        },
        excel: {
          url: '/schedi-vs-excel',
          breadcrumb: 'Schedi vs Excel',
          metaTitle: 'Schedi vs Excel для графіків роботи',
          metaDescription: 'Порівняйте Schedi і Excel для графіків роботи. Подивіться різницю в доступності, обмінах, публікації графіка і звітах.',
          hero: { badge: 'Schedi vs Excel', title: 'Schedi vs Excel для графіків роботи', subtitle: 'Excel добрий на старті. Schedi починає вигравати, коли потрібні доступність, сповіщення, обміни і експорт без ручного контролю версій.', cta: 'Тестувати Schedi', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'Таблиця не є процесом планування', desc: 'Excel зберігає таблицю, але не збирає доступність, не затверджує обміни і не повідомляє працівникам, що готова нова версія.', items: ['Кожна правка створює ризик роботи зі старою версією.', 'Обміни потребують ручного підтвердження.', 'Доступність треба копіювати з повідомлень.', 'Звіти годин залежать від правильних формул.'] },
          solution: { title: 'Schedi додає процес навколо графіка', desc: 'Замість заміни однієї таблиці іншою Schedi зʼєднує графік з доступністю, командою, сповіщеннями і експортом.', items: [{ title: 'Один актуальний графік', desc: 'Команда бачить актуальну версію, а менеджер керує змінами в додатку.' }, { title: 'Менше ручних домовленостей', desc: 'Доступність і обміни мають своє місце та статус.' }, { title: 'Експорт без копіювання', desc: 'PDF і CSV допомагають передати дані далі без копіювання таблиць.' }] },
          cta: { title: 'Перевірте, чи Excel ще вам вистачає', desc: 'Якщо графік займає забагато часу або потребує постійних виправлень, протестуйте Schedi на реальній команді.', button: 'Спробувати безкоштовно' },
        },
        cafe: {
          url: '/grafik-dla-kawiarni',
          breadcrumb: 'Графік для кавʼярні',
          metaTitle: 'Графік роботи для кавʼярні та барист',
          metaDescription: 'Schedi допомагає створювати графік роботи в кавʼярні, збирати доступність барист і публікувати зміни без таблиць та розрізнених повідомлень.',
          hero: { badge: 'Графік для кавʼярні', title: 'Графік роботи кавʼярні в одному вигляді', subtitle: 'Плануйте барист, ранкові, післяобідні та вихідні зміни в одному простому онлайн-інструменті.', cta: 'Спробувати для кавʼярні', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'Кавʼярні потрібен гнучкий графік', desc: 'Потік клієнтів змінюється протягом дня, а доступність студентів, барист і працівників на неповний день може щотижня бути іншою.', items: ['Доступність потрапляє в різні чати і нотатки.', 'Вихідні зміни треба швидко закривати.', 'Нова версія графіка губиться в повідомленнях.', 'Менеджер витрачає час на питання про години роботи.'] },
          solution: { title: 'Schedi впорядковує графік кавʼярні', desc: 'В одному місці ви плануєте персонал, збираєте доступність і даєте команді доступ до актуального графіка.', items: [{ title: 'Доступність барист', desc: 'Збирайте декларації перед плануванням тижня.' }, { title: 'Зміни без таблиць', desc: 'Редагуйте ранки, післяобідні години і вихідні у зрозумілому вигляді.' }, { title: 'Публікація для команди', desc: 'Працівники бачать актуальний графік з телефону.' }] },
          cta: { title: 'Складіть графік кавʼярні онлайн', desc: 'Протестуйте Schedi зі своєю командою і перевірте, скільки повідомлень про графік можна прибрати з тижня.', button: 'Почати тут' },
        },
        bar: {
          url: '/grafik-dla-baru',
          breadcrumb: 'Графік для бару',
          metaTitle: 'Графік роботи для бару і вечірніх змін',
          metaDescription: 'Створюйте графік роботи бару, плануйте вечори і вихідні, збирайте доступність та контролюйте обміни змінами в Schedi.',
          hero: { badge: 'Графік для бару', title: 'Графік роботи бару, вихідних і вечорів', subtitle: 'Schedi допомагає планувати барменів, зал і сезонні зміни без переписування таблиць.', cta: 'Спробувати для бару', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'Вечірні зміни потребують швидких виправлень', desc: 'Бари працюють у години, коли кожна відсутність або заміна швидко впливає на персонал.', items: ['Вихідні зміни найбільш чутливі до браку людей.', 'Обміни в чаті важко контролювати.', 'Доступність команди змінюється щотижня.', 'Менеджеру потрібна одна актуальна версія графіка.'] },
          solution: { title: 'Один графік для всього бару', desc: 'Schedi обʼєднує план змін, доступність і запити на обмін в одному процесі, без ручного контролю версій.', items: [{ title: 'Персонал на вечори', desc: 'Плануйте зміни під реальні години роботи закладу.' }, { title: 'Обміни зі статусом', desc: 'Кожен запит має власника, етап і рішення менеджера.' }, { title: 'Експорт графіка', desc: 'Передавайте готовий план у PDF або CSV без копіювання таблиць.' }] },
          cta: { title: 'Замініть чат контрольованим графіком', desc: 'Якщо графік на вихідні потребує постійних виправлень, перевірте Schedi на реальному робочому тижні.', button: 'Спробувати безкоштовно' },
        },
        hotel: {
          url: '/grafik-pracy-hotel',
          breadcrumb: 'Графік роботи готелю',
          metaTitle: 'Графік роботи готелю для рецепції та обслуговування',
          metaDescription: 'Schedi допомагає планувати графік роботи готелю, рецепції, обслуговування і змінних команд. Збирайте доступність і публікуйте графік онлайн.',
          hero: { badge: 'Графік роботи готелю', title: 'Графік роботи готелю в одному вигляді', subtitle: 'Плануйте рецепцію, обслуговування і погодинні команди без пошуку актуальної версії графіка в таблицях.', cta: 'Спробувати для готелю', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'Готелю потрібна безперервність персоналу', desc: 'Рецепція, обслуговування і чергування потребують передбачуваного плану, а зміни доступності швидко ускладнюють графік.', items: ['Різні ролі потребують окремого контролю персоналу.', 'Ранкові, післяобідні та нічні зміни мають поєднуватися.', 'Відсутності потребують швидкої заміни.', 'Команді потрібен доступ до актуального графіка.'] },
          solution: { title: 'Schedi спрощує планування готельних змін', desc: 'Менеджер бачить команду, доступність і графік в одному місці, а працівники можуть перевіряти свої зміни з телефону.', items: [{ title: 'Ролі і посади', desc: 'Плануйте персонал відповідно до потреб рецепції та обслуговування.' }, { title: 'Актуальний графік', desc: 'Зменшуйте кількість питань про останню версію графіка.' }, { title: 'Звіти годин', desc: 'Експортуйте дані для подальших розрахунків без ручного переписування.' }] },
          cta: { title: 'Впорядкуйте графік готелю онлайн', desc: 'Почніть з однієї команди і перевірте, чи Schedi підходить до вашого процесу планування змін.', button: 'Почати тут' },
        },
        availability: {
          url: '/funkcje/dostepnosc-pracownikow',
          breadcrumb: 'Доступність працівників',
          metaTitle: 'Доступність працівників у графіку роботи',
          metaDescription: 'Збирайте доступність працівників перед створенням графіка. Schedi допомагає менеджерам планувати зміни без пошуку декларацій у повідомленнях.',
          hero: { badge: 'Доступність працівників', title: 'Доступність працівників перед створенням графіка', subtitle: 'Збирайте декларації команди в одному місці і плануйте зміни на основі актуальної інформації.', cta: 'Подивитися доступність у Schedi', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'Графік починається з доступності', desc: 'Якщо доступність живе в повідомленнях, нотатках і памʼяті менеджера, кожен графік має більший ризик помилок.', items: ['Декларації працівників легко пропустити.', 'Часткова доступність потребує ручної перевірки.', 'Зміни треба виправляти після публікації.', 'Менеджер не має одного вигляду перед плануванням.'] },
          solution: { title: 'Schedi збирає декларації в одному місці', desc: 'Працівники вказують, коли можуть працювати, а менеджер бачить доступність перед призначенням змін.', items: [{ title: 'Доступність на день', desc: 'Бачте, хто може працювати в конкретний день.' }, { title: 'Тижневі шаблони', desc: 'Впорядковуйте повторювану доступність команди.' }, { title: 'Менше виправлень', desc: 'Плануйте зміни з меншим ризиком конфліктів.' }] },
          cta: { title: 'Збирайте доступність в одному місці', desc: 'Перенесіть декларації працівників з чату в один процес планування графіка.', button: 'Спробувати Schedi' },
        },
        swaps: {
          url: '/funkcje/zamiana-zmian',
          breadcrumb: 'Обмін змінами',
          metaTitle: 'Обмін змінами працівників під контролем менеджера',
          metaDescription: 'Керуйте обмінами змінами в Schedi. Працівник подає запит, друга особа відповідає, а менеджер затверджує зміну в одному процесі.',
          hero: { badge: 'Обмін змінами', title: 'Обмін змінами без втрати домовленостей', subtitle: 'Запити на обмін проходять зрозумілий процес, замість того щоб губитися в чаті і приватних повідомленнях.', cta: 'Подивитися обміни в Schedi', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'Обміни в чаті швидко втрачають контекст', desc: 'Коли працівники домовляються поза графіком, менеджер мусить вручну перевіряти, хто, коли і на що погодився.', items: ['Не видно, хто прийняв зміну.', 'Менеджер вручну оновлює графік.', 'Стара версія графіка залишається в обігу.', 'Немає історії рішення щодо обміну.'] },
          solution: { title: 'Schedi дає обмінам статус і процес', desc: 'Запит проходить через працівника і менеджера, а графік можна оновлювати без ручного відстеження повідомлень.', items: [{ title: 'Запит на обмін', desc: 'Працівник починає зміну з рівня додатку.' }, { title: 'Згода другої особи', desc: 'Обмін має чітку відповідь перед рішенням менеджера.' }, { title: 'Рішення менеджера', desc: 'Фінальне затвердження залишається в контрольованому процесі.' }] },
          cta: { title: 'Впорядкуйте обміни в команді', desc: 'Замініть ручні домовленості процесом, який менеджер може затвердити без пошуку повідомлень.', button: 'Спробувати безкоштовно' },
        },
        reports: {
          url: '/funkcje/raporty-godzin',
          breadcrumb: 'Звіти годин',
          metaTitle: 'Звіти годин роботи і експорт графіка',
          metaDescription: 'Експортуйте графіки і звіти годин роботи до PDF та CSV. Schedi допомагає менеджерам передавати дані без ручного переписування таблиць.',
          hero: { badge: 'Звіти годин', title: 'Звіти годин роботи без копіювання даних', subtitle: 'Експортуйте графіки, години і дані для подальших розрахунків без ручного копіювання таблиць.', cta: 'Подивитися звіти в Schedi', secondaryCta: 'Подивитися ціни' },
          problem: { title: 'Звіти з таблиці потребують додаткової роботи', desc: 'Коли графіки і зміни виправляються вручну, експорт годин залежить від актуальності таблиці і правильних формул.', items: ['Дані треба копіювати між файлами.', 'Формули легко зламати під час виправлень.', 'PDF графіка створюється вручну.', 'Менеджер витрачає час на впорядкування звіту.'] },
          solution: { title: 'Schedi допомагає передати дані далі', desc: 'Після створення графіка ви можете експортувати дані у форматі, який легше передати команді або використати для подальших розрахунків.', items: [{ title: 'Експорт PDF', desc: 'Підготуйте зрозумілий графік для поширення.' }, { title: 'Експорт CSV', desc: 'Передавайте дані далі без ручного переписування.' }, { title: 'Кращий контроль годин', desc: 'Аналізуйте графік і персонал в одному інструменті.' }] },
          cta: { title: 'Експортуйте графік без ручної роботи', desc: 'Подивіться, як Schedi спрощує звітування годин у малій змінній команді.', button: 'Почати тут' },
        },
      },
      seoPageFaq: {
        program: { title: 'Часті питання про програму для графіків роботи', items: [{ q: 'Що таке програма для графіків роботи?', a: 'Це онлайн-інструмент для створення, публікації та оновлення графіків змін. У Schedi менеджер також може збирати доступність, обробляти обміни і експортувати дані.' }, { q: 'Чи замінює Schedi Excel?', a: 'Так, у плануванні змін. Schedi не є таблицею, а процесом навколо графіка: доступність, команда, публікація, сповіщення і експорт знаходяться в одному місці.' }, { q: 'Чи можна почати з однієї команди?', a: 'Так. Schedi підготовлено для малих команд і може рости разом з компанією без важкого IT-впровадження.' }] },
        restaurant: { title: 'Часті питання про графік роботи ресторану', items: [{ q: 'Чи підходить Schedi для ресторану з кухнею і залом?', a: 'Так. Ви можете планувати різні ролі і команди, а працівники мають доступ до актуального графіка з телефону.' }, { q: 'Чи можуть працівники подавати доступність?', a: 'Так. Доступність є одним з основних елементів Schedi і допомагає складати графік перед публікацією.' }, { q: 'Чи обміни змінами потребують згоди менеджера?', a: 'Так. Обміни можуть проходити процес затвердження, щоб менеджер зберігав контроль над персоналом.' }] },
        excel: { title: 'Часті питання про Schedi vs Excel', items: [{ q: 'Коли Excel перестає вистачати?', a: 'Найчастіше тоді, коли зʼявляються часті обміни, різна доступність працівників, кілька ролей і потреба швидко публікувати актуальну версію графіка.' }, { q: 'Чи Schedi експортує дані до таблиці?', a: 'Так. Ви можете експортувати дані до CSV, якщо потрібно передати їх далі або поєднати з іншим процесом.' }, { q: 'Чи треба одразу переносити весь процес?', a: 'Ні. Можна почати з однієї команди і перевірити Schedi на реальному графіку роботи.' }] },
        cafe: { title: 'Часті питання про графік кавʼярні', items: [{ q: 'Чи підходить Schedi для барист на неповний день?', a: 'Так. Доступність працівників можна зібрати перед створенням графіка, що допомагає гнучким командам.' }, { q: 'Чи графік працює на телефоні?', a: 'Так. Менеджер і працівники можуть користуватися Schedi у браузері на мобільному пристрої.' }, { q: 'Чи можна експортувати графік кавʼярні?', a: 'Так. Schedi підтримує експорт графіка і даних до PDF та CSV.' }] },
        bar: { title: 'Часті питання про графік бару', items: [{ q: 'Чи допомагає Schedi з вихідними змінами?', a: 'Так. Ви можете планувати персонал на вечори і вихідні та швидше реагувати на зміни доступності.' }, { q: 'Чи обміни змінами видимі для менеджера?', a: 'Так. Запити на обмін мають статус і можуть вимагати затвердження менеджера.' }, { q: 'Чи команда бачить актуальну версію графіка?', a: 'Так. Працівники можуть перевірити актуальний графік з телефону.' }] },
        hotel: { title: 'Часті питання про графік готелю', items: [{ q: 'Чи Schedi підтримує різні ролі в готелі?', a: 'Так. Ви можете планувати команду відповідно до ролей і потреб персоналу.' }, { q: 'Чи Schedi є HR-системою?', a: 'Ні. Schedi фокусується на графіку роботи, доступності, обмінах і базових звітах для змінних команд.' }, { q: 'Чи можна почати тільки з рецепції?', a: 'Так. Ви можете впровадити Schedi спочатку для однієї команди і пізніше розширити використання.' }] },
        availability: { title: 'Часті питання про доступність працівників', items: [{ q: 'Як працівник подає доступність?', a: 'Працівник користується додатком у браузері і вводить, коли може працювати. Менеджер бачить декларації перед створенням графіка.' }, { q: 'Чи можна позначити часткову доступність?', a: 'Так. Schedi підтримує повну доступність, часткову доступність і недоступність.' }, { q: 'Чи доступність зменшує кількість виправлень?', a: 'Вона допомагає обмежити помилки, бо менеджер планує на основі декларацій, зібраних в одному місці.' }] },
        swaps: { title: 'Часті питання про обмін змінами', items: [{ q: 'Хто затверджує обмін зміною?', a: 'Процес може включати відповідь другого працівника і рішення менеджера, щоб зберегти контроль над персоналом.' }, { q: 'Чи обміни замінюють домовленості в чаті?', a: 'Так. Замість пошуку домовленостей у повідомленнях менеджер бачить запит і його статус у додатку.' }, { q: 'Чи можна віддати зміну?', a: 'Schedi підтримує потік віддання зміни та класичний обмін між працівниками.' }] },
        reports: { title: 'Часті питання про звіти годин', items: [{ q: 'Які експорти підтримує Schedi?', a: 'Schedi дозволяє експортувати до PDF і CSV, тому легше передати графік або дані далі.' }, { q: 'Чи звіти замінюють кадрову систему?', a: 'Ні. Звіти допомагають впорядкувати дані з графіка, але не замінюють повну кадрово-платіжну систему.' }, { q: 'Чи експорт потребує ручного переписування?', a: 'Ні. Дані походять з графіка в додатку, тому ви обмежуєте ручне копіювання таблиць.' }] },
      },
      contact: {
        title: 'Зв\'яжіться з нами',
        desc: 'Маєте запитання? Ми тут, щоб допомогти вашому бізнесу зростати.',
        emailLabel: 'Email',
        phoneLabel: 'Телефон',
        addressLabel: 'Адреса',
        form: {
          name: 'Ім\'я та прізвище',
          email: 'Електронна пошта',
          message: 'Повідомлення',
          placeholder: 'Чим ми можемо вам допомогти?',
          send: 'Надіслати повідомлення'
        }
      }
    }
  }
};
